import * as shipmentService from '@/api/biz/shipment/shipmentService';
import { $notify, userInfo } from '@/global';
import { OrderStatusType, SystemID, BUSINESS_TAG, ResDocFormat, LabelType, waybillTypeMapping } from '@/api/biz/bizEnum';
import * as checkConstant from '@/api/biz/outbound/checkConstant';
import { formatDateTime,formatDate } from '@/api/utils/date';
import * as  payTypeConstant from '@/api/biz/shipment/pack/payTypeConstant';
import { i18n } from '@/api/i18n';
import { print, collectLabelInfo, convertBase64 } from '@/api/print/print.js';
import { packSetKey, suPackSetKey } from '@/api/biz/outbound/Const';
import * as paperlessPackageTag from '@/api/biz/shipment/pack/paperlessPackageTag';
import * as arrayUtils from '@/api/utils/arrayUtils';
import * as printConst from '@/api/print/constant.js'
import  _  from 'lodash';
import { judgeImgType,printByImgType } from './paperlessPackageTag'
import {qryDicDetailByCatalog,getSysConfigByKey,qryItemBaseForList,getSystemConfig, createBsLogisticsPropertyTask} from '@/api/biz/master/masterService.js'
// eslint-disable-next-line no-unused-vars
import requestTry from '@/api/rest/requestTry';
import { isEmpty } from 'element-ui/src/utils/util'
import {SgmPrintMonitor} from '@/api/lib/monitor/printMonitor'
import dayjs from 'dayjs'
import { printStart,printEnd } from '@/utils/setMethods.js';
import { customizeNotifyWithVoice, NOTIFY_TYPE_ENUM } from '@/api/utils/message.js'
import { addLog } from '../../../lib/addLog.js';
import { getRoutePath } from '@/utils/index.js';
import store from '@/store/store.js';
import { playSoundFail } from '@/api/utils/audio.js'
import { isOriginalConsumable } from "@/api/biz/shipment/pack/resolveWMSOrderAction.js";



/**
       *
       * 校验是否为KK面单
       */
   const checkIsKK=async(obCheckMR)=>{
    if(obCheckMR.checkM){
      let queryFromMaster = {};
      queryFromMaster.orgNo = userInfo.orgNo;
      queryFromMaster.distributeNo = userInfo.distributeNo;
      queryFromMaster.warehouseNo = userInfo.warehouseNo;
      queryFromMaster.bizKey = obCheckMR.checkM.ownerNo;
      queryFromMaster.outboundNo = obCheckMR.checkM.outboundNo;
      const printTypeArray = await paperlessPackageTag.getAbilitiesFromMaster(queryFromMaster);
      const isKK=printTypeArray && printTypeArray.indexOf('outbound_printSheet_KKCallSheetFlag')>-1;
      if(isKK){
        obCheckMR.checkM.KKCallSheetFlag=isKK
      }
    }

  }
/**
 * 打包入口方法
 * @param obCheckMR 待打包订单信息
 * @param outboundNo 订单号(订单号与待打包订单信息不允许同时为空)
 * @param packNum 打包数量：必须传递正整数或null值
 * @param rePackaged 是否重打：true-重打；fasle-正常打印
 * @param platformNo 平台号：打包-打包台号；复核-复核台号
 * @param isSaveWithoutShipNo 是否不带运单号保存包裹信息 如果不需要运单号则提前保存包裹信息否则调用3pl拿到运单号后再保存包裹信息
 *        普通toC/一店一订单需要运单号： false
 *        一店一集合单和一店多集合单不需要运单号：true
 *        非hkm的目前都不需要运单号： true
 * @param isPrint 是否打印：true-打印；false-不打印，HKM一店一集合单和多集合单 在独立打包时不打印正向面单
 */
export const process = async (obCheckMR, outboundNo, packNum, rePackaged, platformNo, isSaveWithoutShipNo, isPrint, tailPackageType) => {
  // 1.校验参数
  if (!obCheckMR) {
    if (!outboundNo) {
      $notify.error("The pack param is empty!");
      return;
    }
    SgmPrintMonitor(`${outboundNo}_pack.process-getObCheckMR-before`, 0, obCheckMR)
    obCheckMR = await getObCheckMR(outboundNo, rePackaged);
    SgmPrintMonitor(`${outboundNo}_pack.process-getObCheckMR-after`, 0, obCheckMR)
    if(!obCheckMR){
      $notify.error("The obtained obCheckMR is empty!");
      return;
    }
    obCheckMR.checkM.tailPackageType = tailPackageType
    //复核-补打
    await checkIsKK(obCheckMR)
    // 是否删除历史包裹,非包裹明细重打包，进入这里需要删除
    if(rePackaged){
      obCheckMR.deleteHistoryPackageFlag = 1
    }
    //校验货主是否有满包裹采集能力，fullPackage,ownerMark 第二位为1:具备满包裹能力
    let OwnerMarkEnumCode = obCheckMR.checkM.businessCapabilityList;
    console.info("货主业务能力->OwnerMarkEnumCode:" + OwnerMarkEnumCode);
    if (arrayUtils.contains(OwnerMarkEnumCode,BUSINESS_TAG.FULL_PACKAGE)) {
      $notify.error(i18n.t('fullPackageNotRePackOrder'));
      return;
    }
    // su升级 打包设置取值调整 兼容老独立打包场景
    if (getRoutePath().includes('suPackNew') && rePackaged) {
      obCheckMR.checkM.localSuPackFlag = true;
    }
  }
  validate(obCheckMR);
  if (packNum && !Number.isInteger(packNum) && Number.parseInt(packNum) <= 0) {
    $notify.error("The packNum is invalid!");
    return;
  }

  if(!(typeof rePackaged == "boolean")){
    $notify.error("The rePackaged is invalid!");
    return;
  }

  if (!platformNo) {
    $notify.error(i18n.t('tlbCheckNoNotBeNull'));
    return;
  }

  // 2.获取打包数量
  let packingOrder = obCheckMR.checkM;
  packingOrder.platformNo = platformNo;
  let packageQty = getPackageQty(packingOrder, packNum);
  if (!packageQty) {
    $notify.error("The obtained packageQty is invalid!");
    return;
  }

  // 3.完善订单信息
  // completeOrder(packingOrder);

  // 4.获取包裹明细
  let listR = getListR(obCheckMR);
  if (!listR) {
    $notify.error("The obtained listR is empty!");
    return;
  }

  // 5.获取打包明细信息 tempPackingDList
  const isHkm2pack = !!(obCheckMR.tempPackingDList && obCheckMR.tempPackingDList.length) // hkm2复核打包使用tempPackingDList暂存明细可以用来判断
  let listPackagingD = [];
  if ((isHkm2pack || isDirectPrint(packingOrder)) && packingOrder.totalQty == 1) {
    listPackagingD = getPackagingDList(listR)
    SgmPrintMonitor(`${packingOrder.outboundNo}_pack.process-submitResult-getPackagingDList-listPackagingD`, 0, {listPackagingD})
    // 增加长宽高
    listPackagingD.forEach(x => {
      x.packageOrder = 1
      x.tailPackageType = tailPackageType
      if (obCheckMR?.listPackageD) {
        for (let i = 0; i < obCheckMR.listPackageD.length; i++) {
          if (x.goodsNo === obCheckMR.listPackageD[i].goodsNo) {
            x.length = obCheckMR.listPackageD[i].length
            x.width = obCheckMR.listPackageD[i].width
            x.height = obCheckMR.listPackageD[i].height

            x.goodsBarcode = obCheckMR.listPackageD[i].goodsBarcode
            x.weight = obCheckMR.listPackageD[i].weight
            x.weightUnit = obCheckMR.listPackageD[i].weightUnit
            x.hsCode = obCheckMR.listPackageD[i].hsCode
            
            x.goodsAliasCode = obCheckMR.listPackageD[i].goodsAliasCode
            
            x.claimValue = obCheckMR.listPackageD[i].price
            x.price = obCheckMR.listPackageD[i].price
            x.sourceCountry = obCheckMR.listPackageD[i].sourceCountry
            x.currency = obCheckMR.listPackageD[i].currency
            break;
          }
        }
      }
    })
  }
  if (obCheckMR.checkType == 'enableScanPackDetail' || (isHkm2pack && packingOrder.totalQty > 1)){
    listPackagingD = obCheckMR.listPackageD;
  }
  let param = {
    obCheckMR : obCheckMR,
    packingOrder : packingOrder,
    rePackaged : rePackaged,
    packageQty : packageQty,
    listR : listR,
    listPackagingD : listPackagingD || [],
    isSaveWithoutShipNo : isSaveWithoutShipNo,
    isPrint: isPrint,
    outboundNo: outboundNo
  };
  // 加日志
  // SgmPrintMonitor(`${packingOrder.outboundNo}_pack.process-submitResult-isSaveWithoutShipNo`, 0, {isSaveWithoutShipNo})
  // SgmPrintMonitor(`${packingOrder.outboundNo}_pack.process-submitResult-packingOrder`, 0, packingOrder)
  // SgmPrintMonitor(`${packingOrder.outboundNo}_pack.process-submitResult-listPackagingD`, 0, {listPackagingD})
  // 6.提交结果
  const result = await submitResult(param);
  return result;
}

/**
 * 获取打包数量
 * @param packingOrder
 */
export const getPackageQty = (packingOrder, packNum) => {
  let packageNum = 0;
  if (packingOrder.totalQty == 1) {
    packageNum = 1;
  } else {
    if (!packNum) {
      $notify.error("The packNum is not allowed to be null!");
      return null;
    }
    if (Number.parseInt(packNum) > packingOrder.totalQty) {
      playSoundFail()
      $notify.error(i18n.t('packageNumDontMoreThanGoodsTotlaNum'));
      return null;
    }
    packageNum = packNum;
  }
  return packageNum;
}

/**
 * 获取待打包订单信息
 * @param outboundNo
 * @param rePackaged
 * @returns {*}
 */
export const getObCheckMR = async (outboundNo, rePackaged) => {
  let obCheckQuery = {
    orgNo: userInfo.orgNo,
    distributeNo: userInfo.distributeNo,
    warehouseNo: userInfo.warehouseNo,
    operateUser: userInfo.userCode,
  };
  if (rePackaged && rePackaged == true) {
    obCheckQuery.outboundNo = outboundNo;
    obCheckQuery.rePackaged = true;
    obCheckQuery.listStatus = [OrderStatusType.STATUS_PACK_FINISHED]
  } else {
    obCheckQuery.caseOrOrderNo = outboundNo;
    obCheckQuery.rePackaged = false;
    obCheckQuery.listStatus = [OrderStatusType.STATUS_FINISHED]
  }
  return shipmentService.getCheckMRForPackaged(obCheckQuery);
}

/**
 * 校验参数
 * @param obCheckMR
 */
export const validate = (obCheckMR) => {
  if (!(obCheckMR && obCheckMR.listCheckR && obCheckMR.listCheckR.length > 0)) {
    $notify.error(i18n.t('containerNoReviewOrder'));
    return;
  }
  if (!obCheckMR.checkM) {
    $notify.error(i18n.t('checkMIsEmpty'));

  }
}

/**
 * 完善订单信息
 * @param param
 */
export const completeOrder = async (packingOrder) => {
  // 获取并设置打包站点信息
  try {
    await setPackageTag(packingOrder);
  } catch (error) {
    console.log("Get and set package site information:" + error);
  }
  // 绑定商品明细、礼品购信息、打包备注显示
  bindDetailAndRemark(packingOrder);
}

/**
 * 获取并设置打包站点信息
 * 获取仓库、站点编码对应的始发地、目的地、滑道号、笼车号，用于包裹标签打印
 * @param packingOrder
 */
export const setPackageTag = async (packingOrder) => {
  let systemId = await shipmentService.getSystemId({});
  console.log("The obtained systemId:" + systemId);
  if (!systemId) {
    return;
  }

  if (systemId == SystemID.SYSTEMID_EPT) {
    packingOrder.packageTag = null;
    return;
  }

  if (systemId == SystemID.SYSTEMID_COMMON && packingOrder.distributeNo == "1101") {
    packingOrder.PackageTag = null;
    return;
  }

  let timeBegin = new Date().getTime();
  packingOrder.sortSlotNo = '';
  packingOrder.packageTag = null;
  let obPackageTag = await shipmentService.getPackageTag(packingOrder);
  if (!obPackageTag) {
    // $notify.error(i18n.t('getFaceAloneInfoIsNull'));
    console.log(i18n.t('getFaceAloneInfoIsNull'));
    return;
  }
  if (!obPackageTag.startDistributeName) {
    $notify.error(i18n.t('getOriginIsNull'));
    return;
  }
  if (!obPackageTag.startCrossCode) {
    $notify.error(i18n.t('startSlotNoIsNull'));
    return;
  }
  if (!obPackageTag.startTabletrolleyCode) {
    $notify.error(i18n.t('startCageNoIsNull'));
    return;
  }
  if (!obPackageTag.targetDistriName) {
    $notify.error(i18n.t('targetDistriNameIsNull'));
    return;
  }
  if (!obPackageTag.targetCrossCode) {
    $notify.error(i18n.t('targetCrossCodeIsNull'));
    return;
  }
  if (!obPackageTag.targetTabletrolleyCode) {
    $notify.error(i18n.t('endCageNoIsNull'));
    return;
  }
  packingOrder.sortSlotNo = obPackageTag.startCrossCode;
  packingOrder.packageTag = obPackageTag;
  let timeEnd = new Date().getTime();
  console.log("获取大全表信息耗时：" + (timeEnd - timeBegin));
  paperlessPackageTag.commonAddLog('pack.js$setPackageTag()',packingOrder.outboundNo,`获取大全表信息耗时：${(timeEnd - timeBegin)}`,{cost: timeEnd - timeBegin})
}

/**
 * 绑定商品明细、礼品购信息、打包备注显示
 * @param packingOrder
 */
export const bindDetailAndRemark = (packingOrder) => {
  // 去掉了显示礼品购订单显示礼品盒明细
  if (packingOrder.resource == checkConstant.SOURCE_ECLP && packingOrder.sendPay &&
    getMaterialScanRemark4ECLP(packingOrder.sendPay)) {

    if (packingOrder.sendPay.substr(21, 1) == "1") {
      packingOrder.packageConsScanType = checkConstant.PACKAGE_CONS_SCAN_TYPE_CONS;
    } else if (packingOrder.sendPay.substr(21, 1) == "2") {
      packingOrder.packageConsScanType = checkConstant.PACKAGE_CONS_SCAN_TYPE_DETAIL;
    }
  }
}

/**
 * 获取ECLP耗材明细采集OR包裹明细采集标识
 * @param sendPay
 */
export const getMaterialScanRemark4ECLP = (sendPay) => {
  let remark = '';
  if (sendPay.length >= 22){
    let mark = sendPay.substr(21, 1);
    if (mark == "1"){
      remark = i18n.t('getSuppliesDetail');
    }
    else if (mark == "2"){
      remark = i18n.t('getPackageDetail');
    }
  }
  return remark;
}

/**
 * 获取包裹明细
 * @param obCheckMR
 */
export const getListR = (obCheckMR) => {
  let listR = []
  let obCheckM = obCheckMR.checkM;
  let listCheckR = obCheckMR.listCheckR;
  for (const cr of listCheckR) {
    let tr = listR.find(t => t.goodsNo == cr.goodsNo);
    if (!tr) {
      let checkNo = ''
      if (obCheckM.checkMode == checkConstant.YES_CODE) {
        checkNo = cr.boxNo;
      } else {
        checkNo = cr.outboundNo;
      }
      tr = {
        unCode: cr.unCode,
        batchNo : cr.batchNo,
        outboundNo : cr.outboundNo,
        goodsNo : cr.goodsNo,
        checkQty : cr.checkQty,
        scanRemainQty : cr.checkQty,
        platformNo : cr.platformNo,
        goodsName : cr.goodsName,
        adultFlag : cr.adultFlag,
        consumable : cr.consumable,
        refrigerant : cr.refrigerant,
        refrigerantQty : cr.refrigerantQty,
        waveType : cr.waveType,
        outboundType : cr.outboundType,
        waveNo : cr.waveNo,
        orgNo : cr.orgNo,
        distributeNo : cr.distributeNo,
        warehouseNo : cr.warehouseNo,
        checkNo: checkNo
      };
      listR.push(tr);
    } else {
      tr.checkQty += cr.checkQty;
      tr.scanRemainQty += cr.checkQty;
    }
    SgmPrintMonitor(`${obCheckM.outboundNo}_pack.process-getListR`, 0, {listR})
    return listR;
  }
}

/**
 * 获取打包明细列表
 * @param listR
 */
export const getPackagingDList = (listR) => {
  let listPackagingD = [];
  let obCheckR = listR[0];
  let packageD = {
    unCode: obCheckR.unCode,
    batchNo: obCheckR.batchNo,
    waveNo: obCheckR.waveNo,
    waveType: obCheckR.waveType,
    outboundNo: obCheckR.outboundNo,
    outboundType: obCheckR.outboundType,
    goodsNo: obCheckR.goodsNo,
    scanCode: obCheckR.scanCode,
    checkQty: obCheckR.checkQty,
    goodsName: obCheckR.goodsName,
    orgNo: obCheckR.orgNo,
    distributeNo: obCheckR.distributeNo,
    warehouseNo: obCheckR.warehouseNo,
    packageOrder: obCheckR.packageOrder,
    goodsWeight: obCheckR.goodsWeight,
    goodsVolume: obCheckR.goodsVolume,
    ownerNo: obCheckR.ownerNo,
    createUser: userInfo.userCode,
    goodsQty: 1
  };
  listPackagingD.push(packageD);
  obCheckR.scanRemainQty = 0;
  return listPackagingD;
}

/**
 * 校验是否直接打印 retVal:true-直接打印；弹框；
 * @param packingOrder
 * @returns {boolean}
 */
export const isDirectPrint = (packingOrder) => {
  let isThirdPayment = (packingOrder.resource != checkConstant.YES_CODE && packingOrder.energySub == 3);
  let useOnePackage = false;
  let packSet = getPackSet(packingOrder.localSuPackFlag);
  console.log(packSet)
  if (packSet.checkList && packSet.checkList.length == 1) {
    useOnePackage = packSet.checkList[0];
  }
  if (packingOrder.totalQty == 1 ||
    useOnePackage ||
    packingOrder.checkMode == checkConstant.YES_CODE ||
    isThirdPayment){
    return true;
  }
  return false;
}

/**
 * 获取打包台设置
 */
export const getPackSet = (suPackFlag) => {
  let packSet = localStorage.getItem(suPackFlag ? suPackSetKey : packSetKey);
  if (!packSet) {
    $notify.error(i18n.t('pleaseSetPackageNo'));
    return null;
  }
  packSet = JSON.parse(packSet);
  if (!packSet.platformNo) {
    $notify.error(i18n.t('pleaseSetPackageNo'));
    return null;
  }
  return packSet;
}

// 包裹长宽高组装
export const buildParcelWeightNew = (packageM, listPackageD,lb) => {
  let currentPackageD = listPackageD.find((item) => {
    return (item.packageNo == packageM.packageNo || (item.outboundNo == packageM.outboundNo && item.packageOrder == packageM.packageOrder))
  })
  console.log('currentPackageD', currentPackageD)
  if(currentPackageD){
    packageM.length = currentPackageD.isOriginalConsumable ? currentPackageD.length : lb.consumableLength ? lb.consumableLength : lb.length
    packageM.width = currentPackageD.isOriginalConsumable ? currentPackageD.width : lb.consumableWidth ? lb.consumableWidth : lb.width
    packageM.height = currentPackageD.isOriginalConsumable ? currentPackageD.height : lb.consumableHeight ? lb.consumableHeight : lb.height;
  }
  // 只有一个包裹时候+非原包，还是用包裹的长宽高
  if (!lb.consumableLength && currentPackageD && currentPackageD.length === 1 && currentPackageD[0].checkQty === 1 && (!packageM.length && !packageM.width && !packageM.height)) {
    packageM.length = currentPackageD[0].length
    packageM.width = currentPackageD[0].width
    packageM.height = currentPackageD[0].height
  }
  return packageM
}
// 包裹长宽高组装
export const buildParcelWeight = (obCheckMR = {}, listLabel = []) => {
  try {
    const {listPackageD = [], listPackageM =[]} = obCheckMR
    let copyListPackageM=JSON.parse(JSON.stringify(listPackageM))
    const lb = listLabel[0] ? listLabel[0] : {}
    copyListPackageM.forEach((packageM) => {
      let currentPackageD = listPackageD.find((item) => {
        return (item.packageNo == packageM.packageNo || (item.outboundNo == packageM.outboundNo && item.packageOrder == packageM.packageOrder))
      })
      console.log('currentPackageD', currentPackageD)
      if(currentPackageD){
        packageM.length = currentPackageD.isOriginalConsumable ? currentPackageD.length : (lb.consumableLength ? lb.consumableLength : (lb.consumableLength == null || lb.consumableLength == '') ? 1 : lb.consumableLength)
        packageM.width = currentPackageD.isOriginalConsumable ? currentPackageD.width : (lb.consumableWidth ? lb.consumableWidth : (lb.consumableWidth == null || lb.consumableWidth == '') ? 1 : lb.consumableWidth);
        packageM.height = currentPackageD.isOriginalConsumable ? currentPackageD.height : (lb.consumableHeight ? lb.consumableHeight : (lb.consumableHeight == null || lb.consumableHeight == '') ? 1 : lb.consumableHeight);
      }
    })
    return copyListPackageM
  } catch (error) {
    console.log(error)
    return obCheckMR.listPackageM
  }
}

// 统一包裹尺重组装（复核打包、独立打包、重打包耗材采集获取包裹长宽高信息）
// 耗材类型是物流袋特殊处理
// TODO: 枚举待和后端确认纸箱、物流袋、原包耗材(1,2,3)
// flag:true  独立打包
// flag:false 复核打包
export const buildLogisticsAttrPackageConsumables = async (listPackingD=[],packageM={}, consumableType = '',checkingOrder={},flag=false,obCheckMR={},listLabel=[]) => {
  try {
    if(!flag){
      // 计算包裹内adr分数
      packageM.adrScore = adrScoreCalc(listPackingD)
      // https://joyspace.jd.com/pages/kQczLcak99BvHgpyW8z9
      // 单一箱规 + （原包、缠绕膜、防水袋、气泡袋）
      const calcSize = getBagLogisticsAtt(listPackingD)
      if(
        listPackingD.length === 1 && 
        listPackingD[0].isBoxSpecification && 
        (['pouch', 'bubble-pouch', 'stretch-film'].includes(consumableType) || isOriginalConsumable(checkingOrder.scanCon))
      ){
        const pd0 = listPackingD[0]
        if(pd0.boxLength && pd0.boxWidth && pd0.boxHeight){
          Object.assign(packageM, {width: pd0.boxWidth, length: pd0.boxLength, height:pd0.boxHeight})
        }else{
          Object.assign(packageM, {width: calcSize.width, length: calcSize.length, height: calcSize.height})
        }
        return packageM
      }

      // 原包、缠绕膜、防水袋、气泡袋
      if(['pouch', 'bubble-pouch', 'stretch-film'].includes(consumableType) || isOriginalConsumable(checkingOrder.scanCon)){
        const totalQty = listPackingD.reduce((sum, item) => sum + Number(item.checkQty || 0), 0)
        // 一包裹一件
        if (totalQty <= 1) {
          Object.assign(packageM, {width: calcSize.width, length: calcSize.length, height: calcSize.height})
        }else{
          let res = {}
          if(['pouch', 'bubble-pouch'].includes(consumableType)){
            try{
              res = await shipmentService.calculateSoftWrapDimWeight({
                listPackageD: listPackingD,
                listConsumable: [checkingOrder.scanCon]
              })
            }catch(e){
              console.log(e)
            }
          }
          if(!res || !res.length || !res.width || !res.height){
            Object.assign(packageM, {width: calcSize.width, length: calcSize.length, height: calcSize.height})
          } else {
            Object.assign(packageM, {width: res.width, length: res.length, height: res.height})
          }
        }
        return packageM
      }
      // 其他场景
      const lb = {}
      for(let packageD of listPackingD){
        lb.isOriginalConsumable = packageD.isOriginalConsumable
        lb.length = packageD.length
        lb.width = packageD.width
        lb.height = packageD.height
      }
      packageM.length = lb.isOriginalConsumable ? lb.length : checkingOrder.consumableLength;
      packageM.width =  lb.isOriginalConsumable ? lb.width : checkingOrder.consumableWidth;
      packageM.height = lb.isOriginalConsumable ? lb.height : checkingOrder.consumableHeight;
      if (!checkingOrder.consumableLength && listPackingD && listPackingD.length === 1 && listPackingD[0].checkQty === 1 && (!packageM.length && !packageM.width && !packageM.height)) {
        packageM.length = listPackingD[0].length
        packageM.width = listPackingD[0].width
        packageM.height = listPackingD[0].height
      }
      // 冷链保温箱，包裹长宽高取保温箱长宽高
      const shipByFreezeBox = store.getters.shipByFreezeBox
      const freezeBoxSize = store.getters.freezeBoxSize
      const {width = '', length = '', height = ''} = freezeBoxSize
      if (shipByFreezeBox && width && length && height) {
        packageM.length = length
        packageM.width = width
        packageM.height = height
      }
      packageM = Object.assign({}, packageM)
      return packageM
    }else{
      let {listPackageD=[],listPackageM =[],listConsumable=[], scanCon = {}} = obCheckMR
      if (!listConsumable) listConsumable = []; // 解决报错
      if (!listPackageD) listPackageD = [];
      if (listConsumable.length === 0) {
        // 仅包裹明细采集的包裹
        for (let packageM of listPackageM) {
          let currentPackageDList = listPackageD.filter((item) => {
            return (item.packageNo === packageM.packageNo || (item.outboundNo === packageM.outboundNo && item.packageOrder === packageM.packageOrder))
          })
          if (currentPackageDList.length === 1 && currentPackageDList[0].checkQty === 1) {
            packageM.length = currentPackageDList[0].length
            packageM.width = currentPackageDList[0].width
            packageM.height = currentPackageDList[0].height
          }else{
            // packageM.length  = 1
            // packageM.width  = 1
            // packageM.height  = 1
          }
          // 冷链保温箱，包裹长宽高取保温箱长宽高
          const shipByFreezeBox = store.getters.shipByFreezeBox
          const freezeBoxSize = store.getters.freezeBoxSize
          const {width = '', length = '', height = ''} = freezeBoxSize
          if (shipByFreezeBox && width && length && height) {
            packageM.length = length
            packageM.width = width
            packageM.height = height
          }
          // 计算包裹内adr分数
          packageM.adrScore = adrScoreCalc(currentPackageDList)
        }
        addLog('single-buildLogisticsAttrPackageConsumables-1', '独立打包非耗材采集场景组装包裹长宽高', {
          outboundNo: checkingOrder?.outboundNo
        });
        return listPackageM
      }

      for(let packageM of listPackageM){
        const currentPackageObj=listConsumable.find((item)=>item.packageNo==packageM.packageNo)
        if(!currentPackageObj) continue
        let currentConsumble=currentPackageObj.packageId
        const currentPackageD = listPackageD.filter((item) => {
          return (item.packageNo == packageM.packageNo || (item.outboundNo == packageM.outboundNo && item.packageOrder == packageM.packageOrder))
        })
        // 计算包裹内adr分数
        packageM.adrScore = adrScoreCalc(currentPackageD)
        if(['pouch', 'bubble-pouch', 'stretch-film'].includes(currentConsumble) || isOriginalConsumable(currentPackageObj)){
          const totalQty = currentPackageD.reduce((sum, item) => sum + Number(item.checkQty || 0), 0)
          const calcSize = getBagLogisticsAtt(currentPackageD)
          if (totalQty <= 1) {
            packageM.length = calcSize.length
            packageM.width = calcSize.width
            packageM.height = calcSize.height
          }else{
            let res = {}
            if(['pouch', 'bubble-pouch'].includes(currentConsumble)){
              try{
                res = await shipmentService.calculateSoftWrapDimWeight({
                   listPackageD: currentPackageD,
                   listConsumable: [currentPackageObj]
                 })
              }catch(e){
                console.log(e)
              }
            }
            if(!res || !res.length || !res.width || !res.height){
              packageM.length = calcSize.length
              packageM.width = calcSize.width
              packageM.height = calcSize.height
            }else{
              packageM.length = res.length
              packageM.width = res.width
              packageM.height = res.height
            }
          }
        }else{
          currentConsumble=listLabel.find((item)=>item.packageNo==packageM.packageNo) ||{}
          let copyPackageM=JSON.parse(JSON.stringify(packageM))
          let newPackageM=buildParcelWeightNew(copyPackageM,listPackageD,currentConsumble)
          Object.assign(packageM, newPackageM)
        }
      }
      return listPackageM
    }
  } catch (error) {
    console.log(error)
    return obCheckMR.listPackageM
  }
}

export const getBagLogisticsAtt=(listPackingD)=>{
  const widthArr=[]
  const lengthArr=[]
  const heightArr=[]
  // 所有商品体积之和（商品体积 = 长 * 宽 * 高 * 件数）
  let totalVolume=0
  listPackingD.forEach(item=>{
    // 取最长为长、次长为宽、最短为高
    let itemAttr=[Number(item.width) || 0,Number(item.height) || 0,Number(item.length) || 0]
    itemAttr.sort((a, b) => b - a);
    let itemLength=itemAttr[0]
    let itemWidth=itemAttr[1]
    let itemHeight=itemAttr[2]
    const itemQty=Number(item.checkQty) || 0
    widthArr.push(itemWidth)
    lengthArr.push(itemLength)
    heightArr.push(itemHeight)
    totalVolume += itemLength * itemWidth * itemHeight * itemQty
  })

  let width=Math.max(...widthArr)
  let length=Math.max(...lengthArr)
  // 高 = 所有商品体积之和 / (长 * 宽)
  let height=0
  const bottomArea=length*width
  if(bottomArea>0 && totalVolume>0){
    height=_.round(totalVolume/bottomArea, 2)
  }else{
    // 长宽或体积取不到值时，兜底为各商品最短边之和
    height=heightArr.reduce((preValue,currentValue)=>preValue+currentValue, 0)
  }
  return {width,length,height}
}

export const getBagConsSize = (curCons, listPackingD) => {
  if (_.isEmpty(curCons)) {
    return {}
  }
  const sort = [curCons.width, curCons.length, curCons.height].sort((a, b) => b - a)
  let height = 0
  listPackingD.forEach(item=>{
    // 取最短为高
    const itemHeight = Math.min(item.width, item.length, item.height)
    height += itemHeight * item.checkQty
  })
  height = Math.min(height, sort[2])

  return {width: sort[1], length: sort[0], height}
}

export const adrScoreCalc = listPackagingD => {
  let adrScore = 0;
  listPackagingD.map(item => {
    if (+item.adrScore > 0) {
      adrScore += (+item.adrScore * item.checkQty)
    }
  })
  return adrScore
}

/**
 * 判断当前订单是否复核完毕
 * @param param
 * @returns {null}
 */
export const submitResult = async (param) => {
  console.log("🚀 ~ submitResult ~ param:", param)
  addLog('submitResult', '独立打包提交', param);
  let obCheckMR = param.obCheckMR;
  let packingOrder = param.packingOrder;
  packingOrder.rePackaged = param.rePackaged;
  packingOrder.scanCon = param.obCheckMR.scanCon;
  let listPackagingD = param.listPackagingD;
  let packageQty = param.packageQty;
  let listR = param.listR;
  let result;
  // 获得发票信息
  // let orderInvoiceInfo = await getOrderInvoiceInfoGlobalization(packingOrder.outboundNo);

  if (packingOrder.totalQty == 1) {
    // 构建包裹箱签信息
    addLog('submitResult2', '', {
      packingOrder: packingOrder.totalQty,
      outboundNo: packingOrder?.outboundNo,
    });
    let packageLabel = await buildPackageLabel(packingOrder, 1, listPackagingD, packageQty);
    let listPackageD = packageLabel.listPackageD;
    SgmPrintMonitor(`${packingOrder.outboundNo}_pack.process.submitResult-listPackageD`, 0, {listPackageD})
    let listPackageM = packageLabel.listPackageM;
    if(packingOrder.packageTotalPropsList && packingOrder.packageTotalPropsList.length && obCheckMR.checkType == 'enableScanPackDetail'){
      packageLabel.listLabel[0].consumableLength = packingOrder.packageTotalPropsList[0].length
      packageLabel.listLabel[0].consumableWidth = packingOrder.packageTotalPropsList[0].width
      packageLabel.listLabel[0].consumableHeight = packingOrder.packageTotalPropsList[0].height
    }
    let listLabel = packageLabel.listLabel;

    // 判断当前订单是否复核完毕
    if (!isOrderCheckFinished(listPackageD, listPackagingD, listR)) {
      console.log("当前订单，订单号：" + packingOrder.outboundNo + "未复核完毕！");
      return;
    }

    // 重置包裹数量和包裹号
    packingOrder.packageQty = listPackageM.length;
    for (const item of listPackageM) {
      item.packageQty = listPackageM.length;
      let packageNoArray = item.packageNo.split('-');
      if (packageNoArray.length >= 3) {
        packageNoArray[2] = listPackageM.length.toString();
      }
      if (!(obCheckMR.checkM && obCheckMR.checkM.splitByPackage)) {
        item.packageNo = packageNoArray.join("-");
      }
    }
    for (const item of listPackageD) {
      item.packageQty = listPackageM.length;
      let packageNoArray = item.packageNo.split('-');
      if (packageNoArray.length >= 3) {
        packageNoArray[2] = listPackageM.length.toString();
      }
      if (!(obCheckMR.checkM && obCheckMR.checkM.splitByPackage)) {
        item.packageNo = packageNoArray.join("-");
      }
    }
    // 将打包结果提交到服务端处理
    param.listPackageD = listPackageD;
    param.listPackageM = listPackageM;
    param.listLabel = listLabel;
    param.listConsumable = obCheckMR.listConsumable
    // 不带运单号保存包裹信息 或者 自营的重打包
    console.log("packingOrder.labelType:" + packingOrder.labelType)
    console.log("param.rePackaged:" + param.rePackaged)
    // 外面给包裹详情赋值下包裹号
    if (!_.isEmpty(param.listPackagingD)) {
      fillPackagegDAndDangerInfo(param);
    }
    // 自营订单非包裹明细采集在这里直接保存包裹，包裹明细采集最后一次满包裹统一保存
    let packageMSaved = {}
    if (param.isSaveWithoutShipNo || ((1 === packingOrder.labelType || 2 === packingOrder.labelType) && param.rePackaged && !obCheckMR.scanPackage && !obCheckMR.scanMaterial)) {
      SgmPrintMonitor(`${packingOrder.outboundNo}_pack.process.addOrderPackage1`, 0, {listPackageD})
      packageMSaved = await addOrderPackage(param);
    }

    if(param.isPrint){
      packingOrder.commonFaceSheet = obCheckMR.commonFaceSheet
      // 打印包裹标签
      result = await printPackageTag(packingOrder, listLabel,param);
    }
    // 仓配单子有返回result 其他的未返回
    if (!result) {
      result = {}
    }
    result.packages = packageMSaved.listPackageM
    result.fnSkuList = packageMSaved.fnSkuList
    result.wholeBatchPackFinished = packageMSaved.wholeBatchPackFinished
    result.printParams = {
      packingOrder,
      listLabel,
      param
    }
  } else {
    if (packingOrder.checkMode != checkConstant.YES_CODE) {
      packingOrder.packageQty = packageQty;
    }

    let listPackageM = [];
    let listLabel = [];
    let packageLabel = {};

    for (let i = 0; i < packageQty; i++) {
      if(packingOrder.packageTotalPropsList && packingOrder.packageTotalPropsList.length && obCheckMR.checkType == 'enableScanPackDetail'){
        console.log(packingOrder.packageTotalPropsList[i])
        packingOrder.packageWeight = packingOrder.packageTotalPropsList[i].weight;
      }
      addLog('submitResult3', '', {
        buildPackageLabelParams2: i + 1,
        outboundNo: packingOrder?.outboundNo
      });
      if (obCheckMR.shippingContainerNoList?.[i]) {
        packingOrder.shippingContainerNo = obCheckMR.shippingContainerNoList[i]
      }
      packageLabel = await buildPackageLabel(packingOrder, i + 1, listPackagingD, packageQty);
      listPackageM = listPackageM.concat(packageLabel.listPackageM)
      if(packingOrder.packageTotalPropsList && packingOrder.packageTotalPropsList.length && obCheckMR.checkType == 'enableScanPackDetail'){
        packageLabel.listLabel[0].consumableLength = packingOrder.packageTotalPropsList[i].length
        packageLabel.listLabel[0].consumableWidth = packingOrder.packageTotalPropsList[i].width
        packageLabel.listLabel[0].consumableHeight = packingOrder.packageTotalPropsList[i].height
      }
      listLabel = listLabel.concat(packageLabel.listLabel)
    }
    param.listPackageM = listPackageM;
    param.listLabel = listLabel;
    param.listConsumable = obCheckMR.listConsumable
    // 外面给包裹详情赋值下包裹号
    if (!_.isEmpty(param.listPackagingD)) {
      fillPackagegDAndDangerInfo(param);
    }

    // 自营配送的单子，多包裹场景，需要在提交202之前更新运单号
    if (packingOrder.selfDeliveryFlag && listPackageM.length > 1) {
      const batchShipNo = await shipmentService.batchGetWayBilNumber({
        size: listPackageM.length - 1,
        customerCode: packingOrder.customerCode
      });
      const waybillCodeList = batchShipNo.waybillCodeList || [];
      waybillCodeList.unshift(packingOrder.shipNo);
      // 此处修改listLabel, 在云打印时还会用到
      listLabel = listLabel.map((item, index) => {
        item.checkShipNo = waybillCodeList[index];
        item.jdwWaybillCode = waybillCodeList[index];
        return item;
      });
      listPackageM = listPackageM.map((item, index) => {
        item.checkShipNo = waybillCodeList[index];
        item.jdwWaybillCode = waybillCodeList[index];
        return item;
      });
    }

    //将打包结果提交到服务端处理
    let packageMSaved = {}
    if (param.isSaveWithoutShipNo || ((1 === packingOrder.labelType || 2 === packingOrder.labelType) && param.rePackaged && !obCheckMR.scanPackage && !obCheckMR.scanMaterial)) {
      SgmPrintMonitor(`${packingOrder.outboundNo}_pack.process.addOrderPackage2`, 0, {listPackageD: param.listPackageD})
      packageMSaved = await addOrderPackage(param);
    }
    if(param.isPrint){
      packingOrder.commonFaceSheet = obCheckMR.commonFaceSheet
      // 打印包裹标签
      result = await printPackageTag(packingOrder, listLabel,param);
    }
    // 仓配单子有返回result 其他的未返回
    if (!result) {
      result = {}
    }
    result.packages = packageMSaved.listPackageM
    result.fnSkuList = packageMSaved.fnSkuList
    result.wholeBatchPackFinished = packageMSaved.wholeBatchPackFinished
    result.printParams = {
      packingOrder,
      listLabel,
      param
    }
  }
  if(packingOrder.allFinished){
    if(packingOrder.allFinished == false){
      $notify.info(i18n.t('operateSuccess'));
    }else {
      if (packingOrder.checkMode == checkConstant.YES_CODE) {
        // $notify.info(i18n.t('package2') + ":" + packingOrder.packageNo + i18n.t('obOrderStatus70') + "!");
      } else {
        // $notify.info(i18n.t('order2') + ":" + packingOrder.outboundNo + i18n.t('obOrderStatus70') + "!");
      }
    }
  }


  window.localStorage.setItem("isPackingCompleted", true);
  return result;
}

/**
 * 构建包裹箱签信息
 * @param packingOrder
 * @param listPackagingD
 * @param packageQty
 * @returns {{}}
 */
export const buildPackageLabel = async (packingOrder, packageOrder, listPackagingD, packageQty) => {
  let packageLabel = {};
  let listPackageM = [];
  let listLabel = [];
  // 获取复核台号
  let platformNo = packingOrder.platformNo;
  // 生成包裹主档
  let packageType = checkConstant.PACK_TYPE_ONLY
  if(packingOrder && packingOrder.waveType === 60 && !packingOrder.repackaged){
    packageType = checkConstant.PACK_TYPE_WALL
  }
  let packageM = await createPackageM(packingOrder, packageOrder, packingOrder.packageWeight, platformNo, packageType);
  console.log("🚀 ~ buildPackageLabel ~ packageM:", packageM)
  // 生成包裹标签
  let pkLabel = createPrepackageLabel(packingOrder, packageOrder, packingOrder.packageWeight, platformNo, packageM);

  // 如果是三方配送订单，添加运单号
  if (isThirdSendShipNo(packingOrder)) {
    let obCarrierInfo = await shipmentService.getShipmentNoList(packingOrder, packageQty);
    if (!obCarrierInfo || !obCarrierInfo.listShipmentNoInfo || obCarrierInfo.listShipmentNoInfo.length == 0) {
      $notify.error(i18n.t('queryThirdExpressCodeIsNull'));
      return null;
    }
    let shipmentNoInfo = obCarrierInfo.listShipmentNoInfo[packageOrder - 1];
    packageM.shipNo = shipmentNoInfo.carrierNo; //第三方运单号
    packageM.branchCode = shipmentNoInfo.branchCode;//第三方运单号对应的网点编码
    packageM.branchName = shipmentNoInfo.branchName;//第三方运单号对应的网点名称
    pkLabel.shipNo = shipmentNoInfo.carrierNo;
    pkLabel.branchCode = shipmentNoInfo.branchCode;
    pkLabel.branchName = shipmentNoInfo.branchName;
  }
  listPackageM.push(packageM);
  listLabel.push(pkLabel);
  // 如果是单包裹，构建包裹明细
  if (packingOrder.totalQty == 1 && listPackagingD && listPackagingD.length > 0) {
    let listPackageD = [];
    for (const item of listPackagingD) {
      if (item.packageNo == packageM.packageNo) {
        listPackageD.push(item);
      }
    }
    listPackagingD = [];
    packageLabel.listPackageD = listPackageD;
  }
  packageLabel.listPackageM = listPackageM;
  packageLabel.listLabel = listPackageM;
  return packageLabel;
}
// 获取sscc(包裹维度打印sscc 随机从订单中的sscc取一个即可)
export const getCurrentSscc = (checkM, packageSqueue) => {
  if (checkM && checkM.orderAction && checkM.orderAction.printSsccByPackage) {
    if (!_.isEmpty(checkM.obShipmentSsccList) && checkM.obShipmentSsccList.length >= packageSqueue) {
      return checkM.obShipmentSsccList[packageSqueue - 1].ssccCode
    }
  }
  return null
}

// 获取包裹维度sscc 从订单中的sscc从前往后取一个即可
export const getCurrentPackageSscc = (checkM, packageSqueue) => {
  if (checkM && checkM.orderAction && (checkM.orderAction.printSsccByPackage || checkM.orderAction.printSsccByPallet)) {
    if (!_.isEmpty(checkM.obShipmentSsccList) && checkM.obShipmentSsccList.length >= packageSqueue) {
      return checkM.obShipmentSsccList[packageSqueue - 1].ssccCode
    }
  }
  return null
}
// 获取托维度sscc 从订单中的sscc从后往前取一个即可
export const getCurrentPalletSscc = (checkM, palletSqueue) => {
  console.log("🚀 ~ getCurrentPalletSscc ~ checkM:", checkM)
  if (checkM && checkM.orderAction && checkM.orderAction.printSsccByPallet) {
    if (!_.isEmpty(checkM.obShipmentSsccList) && checkM.obShipmentSsccList.length >= palletSqueue) {
      return checkM.obShipmentSsccList[checkM.obShipmentSsccList.length - palletSqueue].ssccCode
    }
  }
  addLog('pack.getCurrentPalletSscc', '获取托维度sscc', {
    printSsccByPallet: checkM?.orderAction?.printSsccByPallet,
    obShipmentSsccList: checkM?.obShipmentSsccList?.length,
    palletSqueue
  });
  return null
}

/**
 * 判断三方配送一期 配送编码增加
 * @param obCheckM
 * @returns {boolean}
 */
export const isThirdSendShipNo = (packingOrder) => {
  if (packingOrder.energySub == checkConstant.STATUS_FINISHED) {
    return true;
  }
  return false;
}

/**
 * 批量获取三方快递的运单号
 * @param packingOrder
 * @returns {boolean}
 */
export const getShipmentNoList = async (packingOrder, packageQty) => {
  if (!packingOrder.carrierNo) {
    $notify.error(i18n.t('queryCarrierCodeIsNull'));
    return null;
  }
  let query = {};
  query.carrierCode = packingOrder.carrierNo;
  query.num = packageQty;
  query.status = checkConstant.NO_CODE;
  query.orgNo = packingOrder.orgNo;
  query.distributeNo = packingOrder.distributeNo;
  query.warehouseNo = packingOrder.warehouseNo;

  let obCarrierInfo = await shipmentService.getShipmentNoList(query);
  if(!(obCarrierInfo && obCarrierInfo.listShipmentNoInfo && obCarrierInfo.listShipmentNoInfo.length>0)){
    $notify.error(i18n.t('queryThirdExpressCodeIsNull'));
    return null;
  }
  if (packageQty > obCarrierInfo.listShipmentNoInfo.length) {
    $notify.error(i18n.t('queryThirdExpressNumLessThanPackageNum'));
    return null;
  }
  return obCarrierInfo;
}
/**
 * 生成包裹号
 * @param checkM
 * @param packageOrder
 * @returns {Promise<string>}
 */
export const createPackageNo = (checkM, packageOrder) => {
  console.log("打包生成包裹号")
  let packageNo = ''
  if (!checkM.sortSlotNo) {
    checkM.sortSlotNo = "";
  }
  if (checkM.splitByPackage && checkM.shipNo && checkM.shipNo.includes("-")) {
    console.log("打包生成包裹号,拆单订单使用fop下发的包裹号")
    return checkM.shipNo
  }
  if (checkM.enableFullPackage && checkM.multiPackageCallSheetFlag !== 1) {
    // 包裹明细采集 只打一个包裹的话
    if (checkM.isOnlyOneFullPackage) {
      packageNo = checkM.shipNo + "-" + packageOrder + "-1-" + checkM.sortSlotNo
    } else {
      packageNo = checkM.shipNo + "-" + packageOrder + "-0-" + checkM.sortSlotNo
    }
  } else {
    packageNo = checkM.shipNo + "-" + packageOrder + "-" + checkM.packageQty + "-" + checkM.sortSlotNo
  }
  // hkm CC订单的包裹号规则订单号-门店号-1 例如：PostNL1-JH2020BKP00000000814-1
  if (checkM.orderExtraFlag == 2) {
    packageNo = checkM.outboundNo + "-" + checkM.storeNo + "-" + packageOrder
  } else if (checkM.orderExtraFlag == 1) {
    packageNo = checkM.outboundNo + "-" + packageOrder
  }
  return packageNo
}

/**
 * 生成包裹主档
 * 京东自营订单，包裹号 = 订单号+包裹序号+包裹总数量+始发道口号
 * josl下传的订单， 包裹号 = 运单号 + 包裹序号 + 包裹总数量
 * 外单，sendPay 91 位为1  包裹号 = 运单号 + 包裹序号 + 包裹总数量
 * @param param
 * @constructor
 */
export const createPackageM = async (checkM, packageOrder, weight, platformNo, packageType, turnoverBoxNo) => {
  let packageM = {};
  packageM.waveNo = checkM.waveNo;
  packageM.waveType = checkM.waveType;
  packageM.outboundNo = checkM.outboundNo;
  packageM.outboundType = checkM.outboundType;
  packageM.batchNo = checkM.batchNo;
  packageM.packageQty = checkM.packageQty;
  packageM.packageType = packageType;
  packageM.packageOrder =  packageOrder;
  packageM.turnoverBoxNo = turnoverBoxNo;
  packageM.reverseShipNo = checkM.reverseShipNo;
  // packageM.sscc = getCurrentSscc(checkM, packageOrder)
  packageM.sscc = getCurrentPackageSscc(checkM, packageOrder)
  // 打包机打包满包裹直接存入运单号。并且打包机目前只有单包裹。仓配用这个。自营配送下面就会赋值
  if(checkM.autoPacking){
    packageM.checkShipNo = checkM.jdwWaybillCode;
  }

  const {selfDeliveryFlag, multiPackageCallSheetFlag, customerCode} = checkM;
  if (selfDeliveryFlag) {
    // onePL 前置Call单
    if (multiPackageCallSheetFlag !== 1 && packageM.packageOrder > 1) {
      // 检查是否已经有足够的运单号，避免重复申请
      console.log('1plbatchGetWayBilNumber')
      // 计算还需要申请的单号数量
      const batchShipNo = await shipmentService.batchGetWayBilNumber({
        size: 1,
        customerCode
      });
      packageM.checkShipNo = batchShipNo.waybillCodeList[0];
      packageM.shipNo = batchShipNo.waybillCodeList[0];
    } else {
      packageM.checkShipNo = checkM.splitByPackage ? checkM.shipNo : checkM.jdwWaybillCode;
      packageM.shipNo = checkM.splitByPackage ? checkM.shipNo : checkM.jdwWaybillCode;
    }
  }

  let systemId = await shipmentService.getSystemId();
  if (checkM.sortSlotNo == null) {
    checkM.sortSlotNo = "";
  }
  if (checkM.resource == checkConstant.YES_CODE) {
    if (checkConstant.SYSTEMID_ID == systemId) {
      //印尼包裹号
      packageM.packageNo = checkM.shipNo + "-" + packageM.packageOrder + "-" + checkM.packageQty + "-" + checkM.sortSlotNo;
    } else {
      if (checkM.sendPay && checkM.sendPay.length > 91 && checkM.sendPay.substr(90, 1) == "1") {
        //自营订单并且是外单的包裹号生产规则（海王星）
        packageM.packageNo = checkM.shipNo + "-" + packageM.packageOrder + "-" + checkM.packageQty;
      }
      else {
        //自营订单包裹号生产规则
        packageM.packageNo = checkM.outboundNo + "-" + packageOrder + "-" + checkM.packageQty + "-" + checkM.sortSlotNo;
      }
    }
  } else { //第三方订单的包裹号
    //海外机构包裹号
    if (checkConstant.SYSTEMID_CLOUD == systemId) {
      packageM.packageNo = checkM.shipNo + "-" + packageM.packageOrder + "-" + checkM.packageQty + "-";
    }
    else if (checkConstant.SYSTEMID_EPT == systemId) {
      packageM.packageNo = checkM.outboundNo + "-" + packageOrder + "-" + checkM.packageQty + "-" + checkM.sortSlotNo;
    }
    else if (checkConstant.SYSTEMID_COMMON == systemId) {
      // if (checkM.enableFullPackage) {
      //   // 包裹明细采集 只打一个包裹的话
      //   if(checkM.isOnlyOneFullPackage){
      //     packageM.packageNo = checkM.shipNo + "-" + packageM.packageOrder + "-1-" + checkM.sortSlotNo;
      //   } else {
      //     packageM.packageNo = checkM.shipNo + "-" + packageM.packageOrder + "-0-" + checkM.sortSlotNo;
      //   }
      // } else {
      //   // hkm CC订单的包裹号规则订单号-门店号-1 例如：PostNL1-JH2020BKP00000000814-1
      //   if(checkM.orderExtraFlag == 2){
      //     packageM.packageNo = checkM.outboundNo + "-" + checkM.storeNo + "-" + packageOrder;
      //   }else if (checkM.orderExtraFlag == 1){
      //     packageM.packageNo = checkM.outboundNo + "-" + packageOrder;
      //   }else{
      //     packageM.packageNo = checkM.shipNo + "-" + packageM.packageOrder + "-" + checkM.packageQty + "-" + checkM.sortSlotNo;
      //   }
      // }
      packageM.packageNo = createPackageNo(checkM, packageOrder)
    } else {
      if (checkM.enableFullPackage) {
        // 包裹明细采集 只打一个包裹的话
        if(checkM.isOnlyOneFullPackage){
          packageM.packageNo = checkM.shipNo + "-" + packageM.packageOrder + "-1-" + checkM.sortSlotNo;
        } else {
          packageM.packageNo = checkM.shipNo + "-" + packageM.packageOrder + "-0-" + checkM.sortSlotNo;
        }
      } else {
        packageM.packageNo = checkM.shipNo + "-" + packageM.packageOrder + "-" + checkM.packageQty + "-" + checkM.sortSlotNo;
      }
    }
  }
  addLog('packCreatePackageM', '走到pack createPackageM', {
    packageNo: packageM?.packageNo,
    outboundNo: checkM?.outboundNo,
  });
  packageM.packageWeight = weight;
  packageM.packageVolume = 0.00;
  packageM.sendAddress = checkM.sendAddress;
  packageM.siteNo = checkM.siteNo;
  packageM.sortSlotNo = checkM.sortSlotNo;
  packageM.sendType = checkM.sendType;
  packageM.siteName = checkM.siteName;
  packageM.checkLine = "0";
  packageM.platformNo = platformNo;
  packageM.status = 2;
  packageM.orgNo = userInfo.orgNo;
  packageM.distributeNo = userInfo.distributeNo;
  packageM.warehouseNo = userInfo.warehouseNo;
  packageM.createUser = userInfo.userCode;
  packageM.updateUser = userInfo.userCode;
  packageM.userName = userInfo.userName;
  if (checkM.shippingContainerNo) {
    packageM.shippingContainerNo = checkM.shippingContainerNo
  }
  return packageM;
}

/**
 * 预生成包裹标签（大宗订单复核）
 * 包裹号为空，复核完毕后得到包裹总数后更新包裹号
 * @param checkM
 * @param pkOrder
 * @param platformNo
 * @param packageM
 */
export const createPrepackageLabel = (checkM, pkOrder, weight, platformNo, packageM, enableFullPackage) => {
  // console.log('checkM:' + JSON.stringify(checkM) + ' pkOrder:' + pkOrder)
  let packageLabel = {};
  packageLabel.packageNo = '';
  packageLabel.siteNo = checkM.siteNo;
  packageLabel.sortSlotNo = checkM.sortSlotNo;
  packageLabel.sendAddress = checkM.sendAddress;
  packageLabel.warehouseNo = checkM.warehouseNo;
  packageLabel.checkLine =  "0";//复核线（输送线）
  packageLabel.createTime = formatDateTime(new Date());
  packageLabel.packageWeight = weight;
  if (checkM.checkMode == checkConstant.YES_CODE) {
    packageLabel.packageOrder = checkM.packageOrder; //包裹序号
  } else {
    packageLabel.packageOrder = pkOrder; //包裹序号
  }
  if (checkM.enableFullPackage) {
    packageLabel.packageQty = 0;
  } else {
    packageLabel.packageQty = checkM.packageQty;//包裹总数量
  }
  packageLabel.sendType = checkM.sendType == checkConstant.SELF_SUPPORT_FLAG ? i18n.t('selfSupport') : "";
  packageLabel.siteName = checkM.siteName;
  packageLabel.packageNo = packageM.packageNo;
  packageLabel.platformNo = platformNo;
  // 独立打包的 enableFullPackage 标识在 checkM 上
  if (enableFullPackage || checkM.enableFullPackage) {
    packageLabel.enableFullPackage = true;
  }
  packageLabel.outboundNo = checkM.outboundNo;

  const scanCon = checkM.scanCon || {};
  const {packageId = ''} = scanCon;
  // 后置call单或者耗材是塑料袋的情况下 设置每个包裹的耗材尺寸
  if (checkM.multiPackageCallSheetFlag === 1 || packageId === 'pouch' || packageId === 'bubble-pouch') {
    packageLabel.consumableLength = packageM.length
    packageLabel.consumableWidth = packageM.width
    packageLabel.consumableHeight = packageM.height
  }
  return packageLabel;
}


/**
 * 判断当前订单是否复核完毕
 * @param param
 * @returns {null}
 */
export const isOrderCheckFinished = (listPackageD, listPackagingD, listR) => {
  let checkQty = 0;
  for (const item of listPackageD) {
    checkQty += item.checkQty;
  }
  for (const item of listPackagingD) {
    checkQty += item.checkQty
  }
  let total = 0;
  for (const item of listR) {
    total += item.checkQty;
  }
  if (total == checkQty) {
    return true;
  }
  return false;
}

/**
 * 添加订单包裹信息
 * @param param
 * @returns {null}
 */
export const addOrderPackage = async (param) => {
  let obCheckMR = param.obCheckMR;
  obCheckMR.listConsumable = null;
  // 非包裹明细采集情况下 将所有危险品码都放到包裹维度
  obCheckMR.listPackageM = obCheckMR.allUnCodes ? param.listPackageM.map(i => {
    return {
      ...i,
      unCodes: obCheckMR.allUnCodes
    }
  }) : param.listPackageM
  //param.listPackageD是没值的，obCheckMR.ListPackageD也没用到
  obCheckMR.ListPackageD = param.listPackageD
  obCheckMR.listConsumable = param.listConsumable
  obCheckMR.opUser = getOpuser(param.packingOrder)
  if (obCheckMR.listPackageD && obCheckMR.listPackageD.length) {
    fillPackagegD(obCheckMR);
  }
  // 组装包裹长、宽、高
  console.log('obCheckMR', obCheckMR)
  console.log('param', param)
  // obCheckMR.listPackageM = buildParcelWeight(obCheckMR, param.listLabel)
  let consumablePackageId=obCheckMR.consumablePackageId?obCheckMR.consumablePackageId:''
  let copyObcheckMR = JSON.parse(JSON.stringify(obCheckMR))
  obCheckMR.listPackageM = await buildLogisticsAttrPackageConsumables(param.listPackagingD, copyObcheckMR.listPackageM, consumablePackageId,{},true,copyObcheckMR,param.listLabel)
  // kk需要修改下packageNo， kk且纯仓且有包裹明细
  if(obCheckMR && obCheckMR.checkM && obCheckMR.checkM.KKCallSheetFlag && obCheckMR.checkM.labelType == 1 && !_.isEmpty(obCheckMR.listPackageD)){
    const packageOrderList = obCheckMR.listPackageD.map(packD => packD.packageOrder)
    const maxPackageOrder = Math.max(...packageOrderList)
    const originPackageList = obCheckMR.listPackageD.map(packD => {
      return {
        packageNo: packD.packageNo,
        packageOrder: packD.packageOrder
      }
    })
    // 耗材
    originPackageList.forEach(item => {
      obCheckMR.listConsumable && obCheckMR.listConsumable.forEach(cons => {
        if(item.packageNo === cons.packageNo){
          cons.packageNo = cons.outboundNo + '-' + item.packageOrder + '-' + maxPackageOrder
        }
      })
    })
    // 包裹
    obCheckMR.listPackageD.forEach(packD => {
      packD.packageNo = packD.outboundNo + '-' + packD.packageOrder + '-' + maxPackageOrder
    })
    // 包裹主档
    obCheckMR.listPackageM.forEach(packD => {
      packD.packageNo = packD.outboundNo + '-' + packD.packageOrder + '-' + maxPackageOrder
    })
  }
  // 给包裹主档加上仓单位
  obCheckMR.listPackageM.forEach(packD => {
    if (param?.obCheckMR?.checkM?.extMap?.dimensionsUnit) {
      // 独立打包
      packD.weightUnit = param.obCheckMR.checkM.extMap.weightUnit;
      packD.dimensionsUnit = param.obCheckMR.checkM.extMap.dimensionsUnit;
    } else if (param?.obCheckMR?.extMap?.dimensionsUnit) {
      // 小黄人复核打包
      packD.weightUnit = param.obCheckMR.extMap.weightUnit;
      packD.dimensionsUnit = param.obCheckMR.extMap.dimensionsUnit;
    }
  })
  let timeBegin = new Date().getTime();
  // 上报埋点
  addLog('pack.AddOrderPackage_customer_202', '独立打包上报202日志', obCheckMR);
  let parseRes = {}
  let res = {}
  if (!obCheckMR.checkM?.needNotSubmit202) {
     // 注释后 独立打包可以不提交后端
    res = await shipmentService.addOrderPackage(obCheckMR);
    try {
      parseRes = JSON.parse(res);
      parseRes.wallFinished && customizeNotifyWithVoice(NOTIFY_TYPE_ENUM.success, i18n.t('wallComplete'));
    } catch {}
    let timeEnd = new Date().getTime();
    console.log("添加打包结果耗时：" + (timeEnd - timeBegin));
    paperlessPackageTag.commonAddLog('pack.js$addOrderPackage()',obCheckMR.checkM.outboundNo,`添加打包结果耗时：${(timeEnd - timeBegin)}`, {cost: timeEnd - timeBegin})
  }
  return {
    wholeBatchPackFinished: parseRes.wholeBatchPackFinished,
    fnSkuList: parseRes.fnSkuList,
    listPackageM: obCheckMR.listPackageM,
  }
}

export const getOpuser = (packingOrder) => {
  let opUser = {}
  opUser.userCode = userInfo.userCode;
  opUser.userName = userInfo.userName;
  opUser.userAccount = userInfo.userAccount;
  opUser.checkLine = "0";
  opUser.platformNo = packingOrder.platformNo;
  return opUser;
}

/**
 * 真知码需求判断机构与库房,统一入口
 * @returns {boolean}
 */
export const judgeOrgAndWareHouse = async () => {
  let flag = false;
  if (userInfo.orgNo == "661" && userInfo.distributeNo == "699" &&
    (userInfo.warehouseNo == "601" || userInfo.warehouseNo == "606")) {
    flag = true;
  }
  return flag;
}

/**
 * 从master获取真知码和对应图片流
 * @param obCheckM
 */
export const getCodeNameAndImageBytes = async (obCheckM) => {
  let strImage = await shipmentService.getCodeNameAndImageBytes(obCheckM);
  if (strImage && strImage.carriageNo && strImage.imageBytes.length != checkConstant.NO_CODE) {
    obCheckM.carriageNo = strImage.carriageNo;
    obCheckM.imageBytes = strImage.imageBytes;
  } else {
    $notify.error(i18n.t('queryZcodePicIsNull'));
    return null;
  }
}

/**
 * 填充打包明细数据
 * @param obCheckMR
 * @returns {null}
 */
export const fillPackagegD = (obCheckMR) => {
  for (const packageM of obCheckMR.listPackageM) {
    let flag = false;
    for (const packageD of obCheckMR.listPackageD) {
      if (packageD.packageOrder == packageM.packageOrder) {
        packageD.packageNo = packageM.packageNo;
        flag = true;
      }
    }
    if (!flag) {
      $notify.error(i18n.t('packageDetailNotBeNull'));
      break;
    }
  }
}
/**
 * 填充打包明细数据和危险品数据
 * @param obCheckMR
 * @returns {null}
 */
export const fillPackagegDAndDangerInfo = (param) => {
  let unScoreConfig = param.obCheckMR.unScoreConfig
  console.log('危险品包裹配置',unScoreConfig)
  for (const packageM of param.listPackageM) {
    // 补充耗材里的包裹号
    if(!_.isEmpty(param.listConsumable)){
      for(let consumable of param.listConsumable){
        if(consumable.packageOrder === packageM.packageOrder){
          consumable.packageNo =  packageM.packageNo
        }
      }
    }
    let flag = false;
    let unCodes = []
    let totalBatteryCapacity = 0
    let totalUnCodes = []
    for (const packageD of param.listPackagingD) {
      if (packageD.packageOrder == packageM.packageOrder) {
        packageD.packageNo = packageM.packageNo;
        flag = true;
      }
      if(packageD.packageOrder === packageM.packageOrder &&  packageD.batteryCapacity && +packageD.batteryCapacity > 0){
        totalBatteryCapacity += ((packageD.batteryCapacity ? packageD.batteryCapacity : 0) * packageD.checkQty)
      }

      if(packageD.packageOrder === packageM.packageOrder && packageD.unCode && _.isEmpty(packageD.batteryCapacity)){
        unCodes.push(packageD.unCode)
      }

      if(_.isEmpty(unScoreConfig)){

        if(packageD.packageOrder === packageM.packageOrder && packageD.unCode && _.isEmpty(packageD.batteryCapacity)){
          unCodes.push(packageD.unCode)
        }
      }else{
        if(packageD.packageOrder === packageM.packageOrder && packageD.unCode && _.isEmpty(packageD.batteryCapacity)){
          unCodes.push(packageD.unCode)
        }
        if(packageD.packageOrder === packageM.packageOrder && packageD.unCode && !_.isEmpty(packageD.batteryCapacity) &&
          unScoreConfig.goodsBatteryCapacityLimit && packageD.batteryCapacity > unScoreConfig.goodsBatteryCapacityLimit){
          unCodes.push(packageD.unCode)
        }
      }
    }

    if(_.isEmpty(unScoreConfig)){
      if(!_.isEmpty(unCodes) || totalBatteryCapacity > 100){
        totalUnCodes = (param.listPackagingD.filter(g => g.packageOrder === packageM.packageOrder && g.unCode).map(g => g.unCode))
      }
    }else{
      if(!_.isEmpty(unCodes)){
        totalUnCodes = (param.listPackagingD.filter(g => g.packageOrder === packageM.packageOrder && g.unCode).map(g => g.unCode))
      }
    }

    packageM.unCodes = Array.from(new Set(totalUnCodes)).join(',')
    packageM.dangerousFlag = _.isEmpty(packageM.unCodes) ? 0: 1
    if (!flag) {
      $notify.error(i18n.t('packageDetailNotBeNull'));
      break;
    }
  }
}
/**
 * 根据订单号获得发票信息
 * @param outboundNo
 * @returns {*}
 */
export const getOrderInvoiceInfoGlobalization = async (outboundNo) => {
  let systemId = await shipmentService.getSystemId();
  console.log("getOrderInvoiceInfoGlobalization systemId：" + systemId);
  let invoiceQuery = {};
  invoiceQuery.outboundNo = outboundNo;
  if (checkConstant.SYSTEMID_CLOUD == systemId) {
    let orderInvoiceInfo = {};
    orderInvoiceInfo.orgNo = userInfo.orgNo;
    orderInvoiceInfo.distributeNo = userInfo.distributeNo;
    orderInvoiceInfo.warehouseNo = userInfo.warehouseNo;
    orderInvoiceInfo.receivableTotalAmount = 0;
    orderInvoiceInfo.remark = "";
    orderInvoiceInfo.invoceType ="TH";
    return orderInvoiceInfo;
  } else {
    let listOrderInvoiceInfo = await shipmentService.getOrderInvoiceInfoGlobalization(invoiceQuery);
    if (!listOrderInvoiceInfo || listOrderInvoiceInfo.length <= 0) {
      $notify.error(i18n.t('waveQueryByOrderForInvoiceIsNull'));
      return null;
    }
    let orderInvoiceInfo = listOrderInvoiceInfo[0];
    //支付方式
    orderInvoiceInfo.payTypeValue = payTypeConstant.getPayTypeValueNew(systemId, orderInvoiceInfo.payType);
    return orderInvoiceInfo;
  }
}

/**
 * 复核打印包裹标签
 * @param obCheckM  订单主档信息
 * @param listLabel 面单列表
 * @returns {Promise.<void>}
 */
export const checkPrintPackageTag = async (obCheckM, listLabel, param,printNum = 1) => {
  /**
   * 过滤重复包裹数据、筛选正确的包裹数据
   * */
  // todo 打包机不打单
  if (obCheckM?.jsIsPackageMachineFlag) {
    console.warn("checkPrintPackageTag 打包机不打单");
    return;
  }
  let listLabelNew = []
  let packageNoExistMap = new Map()
  let listLabelNoRepeat = listLabel.filter((a) => !packageNoExistMap.has(a.packageNo) && packageNoExistMap.set(a.packageNo, 1))
  for (let listLabelItem of listLabelNoRepeat) {
    // if(obCheckM.outboundNo == listLabelItem.outboundNo ){
    listLabelNew.push(listLabelItem)
    // }
  }

  if(obCheckM.consumableWeight == null){
    obCheckM.consumableWeight = 0;
  }
  // eslint-disable-next-line no-return-await
  return await printPackageTag(obCheckM, listLabelNew, param,printNum);
}

/**
 * 打印包裹标签
 * @param param
 * @returns {null}
 */
/**
 * 打印包裹标签
 * @param {string} packingOrder - 包裹订单
 * @param {string} listLabel - 列表标签
 * @param {any} param - 参数
 * @param {number} [printNum=1] - 打印数量
 * @returns {Promise<any>} - 返回打印结果的Promise
 */
export const printPackageTag = async (packingOrder, listLabel,param,printNum = 1) => {
  // eslint-disable-next-line no-return-await
  return await paperlessPackageTag.commPrint(packingOrder, listLabel,param,printNum);
}

/**
 * 打印PackingList 明细
 * @param shipmentLabelList
 */
export const doPrintPackingList = (shipmentLabelList) => {
  let printList = [];
  for(let list of shipmentLabelList){
    if(list.faceOrderAddress != null && list.faceOrderAddress != '') {
      let arr = list.faceOrderAddress.split(",");
      for (let v of arr) {
        let printObj = {};
        printObj.faceOrderAddress = v;
        printObj.printType = list.printType
        printObj.labelType = list.labelType
        printList.push(printObj);
      }
    }
  }
  console.log("printPackingList================")
  console.log(printList)
  for (let i = 0; i < printList.length; i++) {
    $("#faceSheetImg" + i).attr('src',"data:image/png;base64," + printList[i].faceOrderAddress);
    $("#printFaaceSheetImgButton" + i).click();
  }
}

/**
 * 打单平台获取箱单/客退单/发票
 * @param labelParam   labelType面单类型: HKM_PL箱单模板 HKM_RS客退模板 HKM_INC发票模板
 * @param printNum 打印份数
 * @returns {null}
 */
export const callPrintPlatform = async (labelParam,printNum = 1,hkmCallFailHandleType) => {
  if(labelParam.labelType){
    let data = {}
    data.docId = labelParam.docId
    data.orderId = labelParam.orderId
    data.templateCode = labelParam.labelType
    data.source = 'WMS'
    data.resDocFormat = ResDocFormat.PNG
    data.resDocType = 1 // 1外部链接 2Base64字符串
    let requiredData = {}
    requiredData.orderNoList = labelParam.orderNoList  // 箱单所需入参
    requiredData.returnLabelUrl = labelParam.returnLabelUrl // 客退单所需入参
    requiredData.goods = labelParam.goods // 客退单所需入参
    if(LabelType.MSJ_INVOICE_LABEL == labelParam.labelType){
      requiredData = labelParam.msjInvoice // 马士基发票所需入参
    }
    data.requiredData = JSON.stringify(requiredData)
    console.log("打单平台获取面单类型为:"+data.templateCode)
    console.log("打单平台获取面单入参为:"+JSON.stringify(data))
    let timeBegin = new Date().getTime();
    paperlessPackageTag.commonAddLog('pack.js$callPrintPlatform().payload', labelParam.orderId, `复核---打单平台获取面单印入参：${JSON.stringify(data)}`)
    let res = await shipmentService.getPrintPlatform(data)
    // let res = await requestTry(shipmentService.getPrintPlatform,1,data)
    let timeEnd = new Date().getTime();
    console.log("打单平台获取面单印耗时（" + labelParam.docId + "）：" + (timeEnd - timeBegin) + "毫秒！")
    try {
      const logContent = _.cloneDeep(res);
      logContent.data.docResults = paperlessPackageTag.batchSubBase64(logContent.data.docResults);
      paperlessPackageTag.commonAddLog('pack.js$callPrintPlatform().result', labelParam.orderId, `复核---打单平台获取面单印结果：${JSON.stringify(logContent)}`, {cost: timeEnd - timeBegin})
    } catch {
      paperlessPackageTag.commonAddLog('pack.js$callPrintPlatform().result', labelParam.orderId, `复核---打单平台获取面单印结果：${JSON.stringify(res)}`, {cost: timeEnd - timeBegin})
    }
    SgmPrintMonitor('call3plAPi_url_printPlatform', timeEnd - timeBegin, res)
    if(res) {
      console.log("打单平台获取面单结果为:"+JSON.stringify(res))
      if(res.code == 0 && res.data.docResults.length > 0){
        // 采用云打印打印面单
        let content = {}
        if(LabelType.INVOICE_LABEL == labelParam.labelType || LabelType.MSJ_INVOICE_LABEL == labelParam.labelType){
          content.templateId = 10
        } else if (LabelType.RETURN_LABEL == labelParam.labelType && res.data.size === '297*210') {
          content.templateId = 101
        }else if (LabelType.RETURN_LABEL == labelParam.labelType){
          content.templateId = 11
        }else if(LabelType.STORE_PACKAGE_LABEL == labelParam.labelType){
          content.templateId = 12
        }else {
          $notify.error('Not support label type to print:' + labelParam.labelType);
          return;
        }
        let data = {}
        content.data = data
        for (let j = 0; j < res.data.docResults.length; j++) {
          data.picture = res.data.docResults[j];
          // C0000000314 C0000001025 C0000000297
          // userInfo.warehouseNo
          // const warehouseNoList = ['C0000000314', 'C0000001025', 'C0000000297', 'C0000000977']
          // if(warehouseNoList.includes(userInfo.warehouseNo) && data.picture.indexOf('storage-cdn.ochama') > -1){
          //   data.picture = data.picture.replace('https://storage-cdn.ochama.com', 'http://storage.ochama.com')
          // }
          await print(content,printNum)
          // 收集打印信息
          const labelTypeCollectByTemplateIDMap = {
            10: 2,
            101: 1,
            11: 1,
            12: 3,
          }
          collectLabelInfo({type: waybillTypeMapping[labelTypeCollectByTemplateIDMap[content.templateId]], size: '', num: printNum});
        }
      }else{
        if(hkmCallFailHandleType != 1){
          $notify.error(i18n.t('callPrintPlatformFailureRemark', [res.msg]));
        }else{
          $notify.warning(i18n.t('callPrintPlatformFailureRemark', [res.msg]));
        }


      }
    }
  } else {
    if(hkmCallFailHandleType != 1){
      $notify.error(i18n.t('1600112'));
    }else{
      $notify.warning(i18n.t('1600112'));
    }
    return null;
  }
}
/**
 * 打单平台获取箱单/客退单/发票
 * @param labelParam   labelType面单类型: HKM_PL箱单模板 HKM_RS客退模板 HKM_INC发票模板
 * @returns {null}
 */
export const callPrintHikPlatform = async (labelParam,printNum = 1) => {
  console.log("打单平台获取面单类型为:"+labelParam.templateCode)
  labelParam.requiredData = JSON.stringify(labelParam.requiredData)
  console.log("打单平台获取面单入参为:"+JSON.stringify(labelParam))
  let timeBegin = new Date().getTime();
  paperlessPackageTag.commonAddLog('pack.js$callPrintHikPlatform().payload', labelParam.docId, `复核---打单平台获取面单印入参：${JSON.stringify(labelParam)}`)
  let res = await shipmentService.getPrintPlatform(labelParam)
  // let res = await requestTry(shipmentService.getPrintPlatform,1,labelParam)
  let timeEnd = new Date().getTime();
  console.log("打单平台获取面单印耗时（" + labelParam.docId + "）：" + (timeEnd - timeBegin) + "毫秒！")
  try {
    const logContent = _.cloneDeep(res);
    logContent.data.docResults = paperlessPackageTag.batchSubBase64(logContent.data.docResults);
    paperlessPackageTag.commonAddLog('pack.js$callPrintHikPlatform().result', labelParam.docId, `复核---打单平台获取面单印结果：${JSON.stringify(logContent)}`, {cost: timeEnd - timeBegin})
  } catch {
    paperlessPackageTag.commonAddLog('pack.js$callPrintHikPlatform().result', labelParam.docId, `复核---打单平台获取面单印结果：${JSON.stringify(res)}`, {cost: timeEnd - timeBegin})
  }
  SgmPrintMonitor('call3plAPi_url_printPlatform', timeEnd - timeBegin, res)
  if(res) {
    console.log("打单平台获取面单结果为:"+JSON.stringify(res))
    if(res.code == 0 && res.data.docResults.length > 0){
      // 采用云打印打印面单
      // 采用云打印打印面单
      let content = {}
      content.templateId = 12
      let data = {}
      content.data = data
      for (let j = 0; j < res.data.docResults.length; j++) {
        data.picture = res.data.docResults[j];
        // collectLabelInfo({type: waybillTypeMapping[0], num: printNum})
        await print(content,printNum)
      }
    }else{
      $notify.warning(i18n.t('callPrintPlatformFailureRemark', [res.msg]));

    }
  }
}

/**
 * 单独打印hkm逆向面单
 * @param labelParam
 * @returns {Promise<void>}
 * @constructor
 */
export const IndependentPrintReverseLabel= async(labelUrl,outboundNo)=>{
  try{
    let imgInfo=labelUrl //逆向面单的url
    let imgType = judgeImgType(imgInfo)
    if ('png' == imgType || 'PNG' == imgType) {
      //png的话 走云打印
      if(labelUrl){
        // 采用云打印打印面单
        let content = {}
        content.templateId = 11 //A4
        let data = {}
        content.data = data
        data.picture = labelUrl
        collectLabelInfo({type: waybillTypeMapping[1]})
        await print(content)
      }
    }else if('pdf' == imgType){
      //pdf走浏览器打印
      collectLabelInfo({type: waybillTypeMapping[1]})
      await printByImgType(labelUrl);//单独打印逆向面单
    }
    printEnd(true)
  }catch (e) {
    console.log("单独打印逆向面单失败error：",e)
  }
}

/**
 * @param labelParam   labelType面单类型:  只打印packingList
 * @returns {null}
 */
export const printLabelByType = async (list,labelType,printNum = 1) => {
  console.log("调用printLabelByType ")
  let labelList = [];
  for(let v of list){
    if(v.labelType == labelType){
      labelList.push(v);
    }
  }
  // 执行打印
  if (labelList.length > 0) {
    let content = {}
    let data = {}
    content.data = data
    for (let i = 0; i < labelList.length; i++) {
      let nonLabel = labelList[i]
      let arr = nonLabel.faceOrderAddress.split(',')
      let timeBegin = new Date().getTime()
      const imgType = judgeImgType(arr[0])
      const isPdf = imgType === 'pdf'
      if ((nonLabel.labelSize === '210*297' || _.isEmpty(nonLabel.labelSize) || nonLabel.labelSize === '')) {
        content.templateId = 11 // A4通用模板
        if (isPdf) {
          arr.forEach(async (item) => {
            let result = await convertBase64(item);
            content.printPDF = 1
            content.pdfSrc = result?.url
            await print(content)
          })
        } else {
          for (let j = 0; j < arr.length; j++) {
            data.picture = arr[j]
          }
          await print(content)
        }
      } else if (nonLabel.labelSize === '297*210') {
        // 横板A4通用模板
        content.templateId = 101
        if (isPdf) {
          arr.forEach(async (item) => {
            let result = await convertBase64(item);
            content.printPDF = 1
            content.pdfSrc = result?.url
            await print(content)
          })
        } else {
          for (let j = 0; j < arr.length; j++) {
            data.picture = arr[j]
          }
          await print(content)
        }
      } else {
        // 其他尺寸默认都用浏览器打印
        let faceInfo = await shipmentService.getFaceInfo({ outboundNo: labelList[0].outboundNo })
        paperlessPackageTag.setFaceSheetStyle(!_.isEmpty(faceInfo) ? faceInfo.faceSize : '')
        for (let j = 0; j < arr.length; j++) {
          paperlessPackageTag.printByImgType(arr[j])
        }
      }
      let timeEnd = new Date().getTime();
      paperlessPackageTag.commonAddLog('pack.js','packingList',"图片地址"+nonLabel.faceOrderAddress+"打印耗时：" + (timeEnd - timeBegin) +"ms", {cost: timeEnd - timeBegin})
      collectLabelInfo({type: waybillTypeMapping[labelType]});
      console.log("复核---打印packingList耗时：" + (timeEnd - timeBegin));
    }
  }
  return labelList.length > 0
}

/**
 * LPN面单数据
 * @param printObj
 * @returns Object
 */
export const getPrintLpnInfoSheet = (printObj) => {
  const {isLpn, printType} = printObj
  // printType   1-入库，2-在库
  if(printType && printType === 2){
    return getInvopLpnPrintInfoSheet(printObj)
  }
  const content = {}
  content.data = {
    "inboundDate": printObj.inboundDate,
    "PI": printObj.inboundNo,
    "itemSku": printObj.outGoodsNo,
    "JDsku": printObj.goodsNo,
    "LPN": printObj.boxRegulations,
    "owner": printObj.ownerName,
    "packSize": printObj.packSize,
    "pcsQty": printObj.receivedQty,
    "caseQty": printObj.caseQty
  }
  content.templatePath = isLpn ? printConst.INBOUND_ACCEPTANCE_SHEET_LPN : printConst.INBOUND_ACCEPTANCE_SHEET_NOT_LPN;
  content.printName = isLpn ? printConst.INBOUND_ACCEPTANCE_LPN : printConst.INBOUND_ACCEPTANCE_NOT_LPN;
  content.templateId = isLpn ? 16 : 17;
  return content
}

/**
 * 在库LPN面单数据
 * @param printObj
 * @returns Object
 */
export const getInvopLpnPrintInfoSheet = (printObj) => {
  const content = {}
  content.data = {
    "inboundDate": printObj.inboundDate,
    "itemSku": printObj.outGoodsNo,
    "JDsku": printObj.goodsNo,
    "LPN": printObj.boxRegulations,
    "owner": printObj.ownerName,
    "packSize": printObj.packSize,
    "pcsQty": printObj.receivedQty,
    "caseQty": printObj.caseQty
  }
  content.templateId = 38
  return content
}

/**
 * 通用箱单packingList 数据
 * @param packType:1：复核打包，2：独立打包，3：单据打印（补打）
 * @param printObj
 * @param printNum 打印份数
 * @returns Object
 */
export const buildCommonPackingListDatas = async (packType,printObj,printNum = 1) => {
  console.info("打印通用箱单packingList组装数据")
  let content = {}
  let contentList = []
  content.templatePath =printConst.OUTBOUND_COMMON_PACKINGLIST;
  content.printName =printConst.OUTBOUND_COMMON_PACKINGLIST_DOC;
  content.templateId =25;
  let listPackagingD = []
  if([1, 2].includes(packType)){
    listPackagingD =  await rebuildRecheckPackAndAlonePackD(packType,printObj.commonPackListD);
   // console.log('listPackagingD>>>>>>',listPackagingD,printObj)
  }else if(packType === 3){
    listPackagingD = printObj.listPackageD
   // console.log('单据打印/补打listPackagingD>>>>>>',listPackagingD,printObj)
  }
  if (_.isEmpty(listPackagingD) || typeof (listPackagingD) == "undefined" || listPackagingD === "") {
    $notify.info(i18n.t('packageDetailsIsNullCannotPrint'))
    return
  }
  let dimensionsUnit= await getSysConfigByKey('dimensionsUnit');
  if(!dimensionsUnit || !dimensionsUnit.trim()){
    dimensionsUnit='mm'
  }
  const volumeUnit=`${dimensionsUnit}³`
  if([1, 2].includes(packType)){
    let checkM = printObj.checkM
    //获取重量单位
    let weightUnit = await getSysConfigByKey('weightUnit')
    if(!weightUnit || !weightUnit.trim()){
      weightUnit='kg'
    }

    content.data = {
      customerNo: checkM.channelsOutboundNo,
      receiveAddress: checkM.sendAddress,
      receiver: checkM.contacter,
      receiveTel: checkM.tel,
      refNo: checkM.outboundNo,
      shippingDate: checkM.endTime,
      trackingNo: checkM.trackingNo,
      unit: weightUnit,
      packageList:[],
      volumeUnit
    }
    let index = 0;
    let packageNo = ''
    for (let item of listPackagingD){
      packageNo = item.packageNo
      let packageTotalWeight = 0;
      let packageTotalVolume = 0;
      if(item.printGoodsQty != null && item.printGoodsWeight != null) {
        packageTotalWeight = packageTotalWeight + (item.printGoodsQty * item.printGoodsWeight);
      }
      if(item.printGoodsQty != null && item.goodsVolume!= null){
        packageTotalVolume = packageTotalVolume + item.printGoodsQty * item.goodsVolume;
      }
      index++
      let packageD = {
        qty: item.printGoodsQty,
        serialNum: index,
        skuName: item.goodsName,
        weight: packageTotalWeight.toFixed(2),
        barcode: item.printBarcode,
        volume:packageTotalVolume.toFixed(2)
      }
      let goodsQueryList = [];
      let goodsQuery = {};
      goodsQuery.goodsNo = item.goodsNo;
      goodsQuery.distributeNo = userInfo.distributeNo;
      goodsQuery.orgNo = userInfo.orgNo;
      goodsQuery.warehouseNo = userInfo.warehouseNo;
      goodsQueryList.push(goodsQuery);
      //查询商品属性获取商家sku
      let goodsList = await qryItemBaseForList(goodsQueryList);
      console.log("查询商品属性获取商家sku结果：" + JSON.stringify(goodsList))
      //查询商品属性获取商家sku
      goodsList.map((it)=>{
        if(it.serialManageFlag === '1' && !checkM.checkGoodsAndSerialCodeFlag){
          packageD.barcode = it.goodsBarcodeList[0]
        }
      })
      packageD.skuCode = goodsList[0].goodsAliasCode;
      content.data.packageList.push(packageD)
    }
    content.data.packageNo = packageNo
    contentList.push(content)
  }else if(packType === 3){

    let reprintPackD =  await rebuildReprintPackD(listPackagingD);
    console.log("🚀 ~ buildCommonPackingListDatas ~ reprintPackD:", reprintPackD)
    for (let data of reprintPackD) {
      content.data = {...data,volumeUnit}
      contentList.push(JSON.parse(JSON.stringify(content)))
    }

  }
  if (packType === 3){
    content.data.shippingDate = formatDateTime(content.data.packageList[0] &&  Math.max(...content.data.packageList.map(item => item.shippingDate)))
  }else{
    content.data.shippingDate = formatDateTime(new Date())
  }
  try {
    // 执行打印
    for (const item of contentList) {
      collectLabelInfo({type: waybillTypeMapping[3], num: printNum})
      await print(item,printNum)
    }
  } catch (error) {
    console.log("打印通用箱单packingList error------------" + error)
  }
}

//复核打包和独立打包打印通用箱单包裹明细重新聚合
export const rebuildRecheckPackAndAlonePackD = async (packType,commonPackListD) => {
  //此时还未生成包裹号，用包裹序号-商品编号-扫描的号（条码，唯一码，序列号)分组
  const res = new Map();
  if(packType === 1){
    commonPackListD.filter((arr) =>
      !res.has(arr.goodsNo) && res.set(arr.goodsNo,arr));
  }else if (packType === 2){
    commonPackListD.filter((arr) =>
      !res.has(arr.packageOrder) && !res.has(arr.goodsNo) && res.set(arr.packageOrder + "-" +arr.goodsNo,arr));
  }
  let newPackListD =[];
  for(let [key, value] of res){
    let sumGoodsWeight = 0;
    let sumGoodsQty =0;
    let reassignKey= '';
    let appendBarcode = ""
    for(let item of commonPackListD){
      //同一个包裹，同一个sku合并到一起，scanCode用换行符分隔
      let oldKey = ""
      if(packType === 1){
        oldKey = item.goodsNo;
      }else if (packType === 2){
        oldKey = item.packageOrder + "-" + item.goodsNo;
      }
      let barcode = item.inputValue ? item.inputValue : item.scanCode;
      //重新计算数量，重量，体积，打包件数
      if(oldKey === key){
        reassignKey = oldKey
        sumGoodsWeight += item.goodsWeight;
        sumGoodsQty += item.goodsQty;
        if(!_.isEmpty(barcode) && typeof (barcode) != "undefined" && !appendBarcode.includes(barcode)){
          appendBarcode = appendBarcode + barcode + "\n"
        }
      }
    }
    //要单独在循环外面赋值，不然整个list都会被改变
    if(key === reassignKey){
      value.printGoodsWeight = sumGoodsWeight;
      value.printGoodsQty = sumGoodsQty;
      value.printBarcode = appendBarcode;
    }
    newPackListD.push(JSON.parse(JSON.stringify(value)))
  }
  return newPackListD;
}

//单据打印补打通用箱单包裹明细重新聚合
//单据打印补打通用箱单包裹明细重新聚合
export const rebuildReprintPackD = async (commonPackListD) => {
  //后台已按照包裹号分组，只需用商家sku重新聚合计算数量等
  for(let pd of commonPackListD){
    let packageList = pd.packageList
    const res = new Map();
    packageList.filter((arr) =>
      !res.has(arr.skuCode) && res.set(arr.skuCode,arr));
    let newPackListD =[];
    let serialNum = 0;
    for(let [key, value] of res){
      let sumQty = 0;
      let sumWeight = 0;
      let reassignKey= '';
      let appendBarcode = "";
      let sumVolume =0;
      for(let item of packageList){
        //同一个sku合并到一起，barcode用换行符分隔
        let oldKey = item.skuCode;
        let barcode = item.barcode;
        //重新计算数量，重量，体积，打包件数
        if(oldKey === key){
          reassignKey = oldKey
          sumQty += item.qty;
          sumWeight += item.weight * item.qty;
          sumVolume += item.goodsVolume * item.qty;
          if(!_.isEmpty(barcode) && typeof (barcode) != "undefined" && !appendBarcode.includes(barcode)){
            appendBarcode = appendBarcode + barcode + "\n"
          }
        }
      }
      //要单独在循环外面赋值，不然整个list都会被改变
      if(key === reassignKey){
        value.qty = sumQty;
        value.weight = sumWeight;
        value.barcode = appendBarcode;
        value.serialNum += serialNum;
        value.volume=sumVolume.toFixed(2)
        value.shippingDate = pd.shippingDate
      }
      newPackListD.push(JSON.parse(JSON.stringify(value)))
    }
    pd.packageList = newPackListD
  }
  return commonPackListD;
}


/**
 * 生成一些打面单的参数
 * */
export const createPrintLabelParam = (checkingOrder, packageSeqNum, listPackagingD, obCheckCM) => {
  // 遍历obCheckCM,得到正在打包的商品对应的客户sku编码
  for (let checkMP of obCheckCM.listCheckMP) {
    if (checkMP.checkM.outboundNo === checkingOrder.outboundNo) {
      for (let i = 0; i < listPackagingD.length; i++) {
        checkMP.listCheckP.forEach(checkP => {
          if (listPackagingD[i].goodsNo === checkP.goodsNo) {
            listPackagingD[i].goodsAliasCode = checkP.goodsAliasCode
            if (checkingOrder.checkMode == checkConstant.YES_CODE) {
              listPackagingD[i].packageOrder = checkingOrder.packageOrder; //包裹序号
            } else {
              listPackagingD[i].packageOrder = packageSeqNum; //包裹序号
            }
          }
        })
      }
      break
    }
  }
  let param = {
    listPackagingD: listPackagingD,
    isSaveWithoutShipNo: true
  }
  return param
}

/**
 * 判断是否打印发票
 * @param printObj
 * @returns Object
 */
export const needPrintInvoice = (receiverCountry,orderLocal,noPrintCountry) => {
  if(!_.isEmpty(noPrintCountry)){
    let code = receiverCountry + "&" + orderLocal;
    for(let detail of noPrintCountry) {
      if (code == detail.code) {
        return true
      }
    }
  }
  return false
}

// 根据code获取字典数据
export const qryDicDetailByCode = (code, userInfo) => {
  const dicDetails = qryDicDetailByCatalog({
    code: code,
    orgNo: userInfo.orgNo,
    distributeNo:userInfo.distributeNo,
    warehouseNo:userInfo.warehouseNo
  })
  return dicDetails
}

/**
 * 校验调用打单平台接口参数
 * @param labelParam  单据参数
 * @returns {null}
 */
export const checkLabelParam = async (labelParam) => {
  if(_.isEmpty(labelParam.docId)){
    $notify.error('docId Cannot be empty!')
    return
  }
  if(_.isEmpty(labelParam.orderId)){
    $notify.error('orderId Cannot be empty!')
    return
  }
  if(_.isEmpty(labelParam.labelType)){
    $notify.error('labelType Cannot be empty!')
    return
  }
  if(labelParam.templateId === undefined || labelParam.templateId === null){
    $notify.error('templateId Cannot be empty!')
    return
  }
  if (![10, 11, 12].includes(labelParam.templateId)) {
    $notify.error('Not support label type to print:' + labelParam.templateId)
    // eslint-disable-next-line no-useless-return
    return
  }
}

/**
 * 调用打单平台老接口获取对应模板的单据
 * @param labelParam  单据参数
 * @returns {null}
 */
 export const callPrintPlatformOldInterface = async (labelParam,printNum = 1) => {
  console.info("printMinisoPackingList labelParam:" + JSON.stringify(labelParam));
  // 参数校验
  await checkLabelParam(labelParam)

  let data = {}
  data.docId = labelParam.docId  // 模板ID
  data.orderId = labelParam.orderId  // 单据编码
  data.templateCode = labelParam.labelType // 模板类型
  data.source = 'WMS'
  data.resDocFormat = labelParam.resDocFormat || ResDocFormat.PNG
  data.resDocType = 1 // 1外部链接 2Base64字符串
  data.requiredData = JSON.stringify(labelParam.requiredData)

  console.log("打单平台老接口获取面单类型为:"+data.templateCode)
  console.log("打单平台老接口获取面单入参为:"+JSON.stringify(data))

  let timeBegin = new Date().getTime();
  paperlessPackageTag.commonAddLog('pack.js$callPrintPlatformOldInterface().payload', labelParam.docId, `复核---打单平台老接口获取面单印入参：${JSON.stringify(data)}`)
  let res = await shipmentService.getPrintPlatform(data)
  let timeEnd = new Date().getTime();
  console.log("打单平台老接口获取面单印耗时（" + labelParam.docId + "）：" + (timeEnd - timeBegin) + "毫秒！")
  // 添加日志
  try {
    const logContent = _.cloneDeep(res);
    logContent.data.docResults = paperlessPackageTag.batchSubBase64(logContent.data.docResults);
    paperlessPackageTag.commonAddLog('pack.js$callPrintPlatformOldInterface().result', labelParam.docId, `复核---打单平台老接口获取面单印结果：${JSON.stringify(logContent)}`, {cost: timeEnd - timeBegin})
  } catch {
    paperlessPackageTag.commonAddLog('pack.js$callPrintPlatformOldInterface().result', labelParam.docId, `复核---打单平台老接口获取面单印结果：${JSON.stringify(res)}`, {cost: timeEnd - timeBegin})
  }
  // paperlessPackageTag.commonAddLog('pack.js.callPrintPlatformOldInterface-call3plAPi_url_printPlatform','callPrintPlatformOldInterface',`复核---打单平台老接口获取面单印耗时：${(timeEnd - timeBegin)}`, {cost: timeEnd - timeBegin})
  SgmPrintMonitor('call3plAPi_url_printPlatform', timeEnd - timeBegin, res)

  if(res) {
    console.log("打单平台老街口获取面单结果为:"+JSON.stringify(res))
    if(res.code == 0 && res.data.docResults.length > 0){
      if (data.resDocFormat === ResDocFormat.PDF) {
        // 导出PDF
        for (let j = 0; j < res.data.docResults.length; j++) {
          window.open(res.data.docResults[j])
        }
      }else{
        // 采用云打印打印面单
        let content = {}
        let data = {}
        content.templateId = labelParam.templateId
        content.data = data
        for (let j = 0; j < res.data.docResults.length; j++) {
          data.picture = res.data.docResults[j];
          await print(content,printNum)
        }
      }
    }else{
      $notify.error(i18n.t('callPrintPlatformOldInterface FailureRemark', [res.msg]));

    }
  }
}


/**
 * CC 一店一集合单和一店多集合单 打印包裹号
 * @param labelParam  单据参数
 * @returns {null}
 */
 export const printCCPackage = async (checkM,totalPackageCount) => {
  console.log('一店一集合单和一店多集合单 checkM:' + JSON.stringify(checkM) + " totalPackageCount: " + totalPackageCount)
  let param = {
    outboundNo:checkM.outboundNo
  }
  let orderInfo = await shipmentService.queryShipmentMExpandAttr(param)
  console.log('一店一集合单和一店多集合单 orderInfo:' + JSON.stringify(orderInfo))
  // 打印箱签
  var data = {}
  // 补充操作人
  if(orderInfo){
    data.consigneeName = orderInfo.custName
    if(orderInfo.obExpand){
      if(orderInfo.obExpand.storeNo){
        data.storeNo = orderInfo.obExpand.storeNo
      }
      if(orderInfo.obExpand.salesPlatformOrder){
        data.salesPlatformOrder = orderInfo.obExpand.salesPlatformOrder
      }
      if(orderInfo.obExpand.busiOutboundNo){
        data.busiOutboundNo = orderInfo.obExpand.busiOutboundNo
      }
    }
  }
  // 如果补打，则取包裹表数据
  if(checkM.isReprint){
    data.packageNo = checkM.packageNo
    data.packagingDate = formatDate(checkM.createTime)
  }else{ // 第一次打印则组装数据
    if(orderInfo.obExpand.storeNo){
      data.packageNo = checkM.outboundNo + '-' + orderInfo.obExpand.storeNo + '-' + totalPackageCount
    }
    data.packagingDate = formatDate(new Date())
  }

  console.log('打印包裹面单 CC data:' + JSON.stringify(data))
  try {
    let content = {}
    content.templateId = 35 // CC模板
    content.data = data
    console.log('打印包裹面单 CC content:' + JSON.stringify(content))
    if(checkM.isReprint){
      // 补打，可以打印多份
      await print(content,totalPackageCount)
    }else{
      // collectLabelInfo({type: waybillTypeMapping[0], size: ''});
      await print(content)
    }
  } catch (error) {
    console.log("------------" + error)
  }
 }

/**
 * 包裹里任一商品对应的边长(最长、次长和最短)大于等于耗材对应边长需要调用主数据生成物流属性采集任务
 * @param consumable
 * @param listPackagingD
 * @returns {Promise<void>}
 */
export const notifyCollectLogisticsAttributes = async (consumable, listPackagingD) => {
  console.info('检查耗材-->' + JSON.stringify(consumable) + '和包裹内商品' + JSON.stringify(listPackagingD) + '边长是否超标')
  if (_.isEmpty(listPackagingD) || listPackagingD.length <= 0) {
    return
  }
  try {
    let param = {}
    param.source = 1 // 来源（1.耗材采集；2.尾程对碰）
    param.createUser = userInfo.userCode
    let goodsNos = []
    for (let packageD of listPackagingD) {
      if (goodsNos.includes(packageD.goodsNo)) {
        continue
      }
      let maxConsLength = Math.max(consumable.length, consumable.width, consumable.height)
      let maxGoodsLength = Math.max(packageD.length, packageD.width, packageD.height)
      if (maxGoodsLength >= maxConsLength) {
        goodsNos.push(packageD.goodsNo)
        continue
      }
      let minConsLength = Math.min(consumable.length, consumable.width, consumable.height)
      let minGoodsLength = Math.min(packageD.length, packageD.width, packageD.height)
      if (minGoodsLength >= minConsLength) {
        goodsNos.push(packageD.goodsNo)
        continue
      }
      let skuSideLengths = [packageD.length, packageD.width, packageD.height]
      let consumableSideLengths = [consumable.length, consumable.width, consumable.height]
      consumableSideLengths.splice(consumableSideLengths.indexOf(maxConsLength), 1)
      consumableSideLengths.splice(consumableSideLengths.indexOf(minConsLength), 1)
      skuSideLengths.splice(skuSideLengths.indexOf(maxGoodsLength), 1)
      skuSideLengths.splice(skuSideLengths.indexOf(minGoodsLength), 1)
      if (skuSideLengths[0] >= consumableSideLengths[0]) {
        goodsNos.push(packageD.goodsNo)
      }
    }
    if (!_.isEmpty(goodsNos) && goodsNos.length > 0) {
      param.type = 0 // 类型-(0-商品 1-箱规 2-耗材)
      goodsNos.forEach(goodsNo => {
        param.code = goodsNo
        param.conCode = consumable.conCode
        createBsLogisticsPropertyTask(param)
      })
      param.type = 2 // 类型-(0-商品 1-箱规 2-耗材)
      param.code = consumable.conCode
      createBsLogisticsPropertyTask(param)
    }
  } catch (e) {
    console.error('检查耗材-->' + JSON.stringify(consumable) + '和包裹内商品' + JSON.stringify(listPackagingD) + '边长是否超标异常',e)
  }

}

// 耗材采集校验货主
export const validateOwnerAndPackageId = (consList, obCheckM) => {
  const { matchConsumablesToOwner, checkM } = obCheckM;
  console.log('consList',consList, '=======>>>>>', obCheckM)
  // 开启 强校验耗材与货主匹配选项
  if (matchConsumablesToOwner) {
    const ownerNo = checkM.ownerNo;
    // 耗材类型自采/代采的，校验通过
    const filteredCons = consList.filter(row =>{
      // 先匹配货主编码，再匹配客户编码
      return row.ownerId === 'merchant' && (
        row.ownerNo === ownerNo || (String(row.customerControlFlag) === '1' && row.customerCode && checkM.customerCode && row.customerCode === checkM.customerCode)
      )
    });
    // 如果匹配到货主/客户则通过校验
    if (filteredCons.length > 0) {
      return true;
    }
    // 如果匹配不到货主，则尝试找到第一条耗材类型不为空的耗材校验是否原包出库
    const cons = consList.find(row => row.packageId);
    // 耗材类型自采/代采的，校验通过
    const ownerCons = consList.some(row => (row.ownerId=='jd' || row.ownerId=='delegate'));

    // 如果全部为空就跳过校验
    if (!cons) return true;
    return (cons.packageId && cons.packageId === 'original') || ownerCons;
  } else {
    // 如果耗材类型为空或自采耗材时  通过
    const cons = consList.find(row => !row.ownerId);
    const jdCons = consList.find(row => (row.ownerId === 'jd' || row.ownerId=='delegate'))
    if (cons || jdCons) return true
    // 如果包含当前货主 通过校验
    const ownerNo = checkM.ownerNo;
    const filteredCons = consList.filter(row => {
      return row.ownerNo === ownerNo || (String(row.customerControlFlag) === '1' && row.customerCode && checkM.customerCode && row.customerCode === checkM.customerCode);
    });
    // 如果匹配到货主则通过校验
    if (filteredCons.length > 0) {
      return true;
    }
    return false
  }
}
